export const bzSpeakers = [
    {
        "id": "RXZlbnRQZW9wbGVfMzA5NDI4MzI=",
        "type": null,
        "firstName": "Pat",
        "lastName": "Thaker",
        "jobTitle": "Editorial Director, Middle East & Africa",
        "organization": "The Economist",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/fcc1f306f0fc4f4d8645db432a444dfa.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU3Ng==",
                "title": "The Global Geopolitical Landscape and its Influence on the Hospitality Industry",
                "categories": [
                    "Projects & Destinations",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyOTk0Mg==",
                "title": "Unveiling Global Affairs: An Open Conversation With Pat Thaker, Editorial Director MEA, the Economist Intelligence Unit",
                "categories": [
                    "Investment & Development",
                    "Workshop"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "workshop",
                        "translations": [
                            {
                                "value": "Workshop"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzA5NjQyMjg=",
        "type": "Moderator",
        "firstName": "Stephen",
        "lastName": "Sackur",
        "jobTitle": "Presenter",
        "organization": "HARDTalk",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/03618d250d2f4c30aebff7f3a994a651.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAwMA==",
                "title": "\"A Global Entrepreneur’s Vision\" - Stephen Sackur, Presenter of HARDtalk in an Exclusive Fireside Chat with H.E. Mohamed Ali Rashed Alabbar",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMjk5Mw==",
                "title": "Turning the Tables: Hard Talk of Stephen Sackur on his view of Global Journalism in a Changing World",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMjk4NQ==",
                "title": "Navigators of Change: Insights of a CEO’s Journey",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTU3NjUxNg==",
                "title": "Redefining the Future: A New Generation of Leadership in Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzA0OQ==",
                "title": "Tourism-Led Policies for a Better World: The Importance of the Industry Getting a Seat at the Government Policy-making Table",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU5MQ==",
                "title": "Leveraging Global Opportunities in Today’s Competitive Business World",
                "categories": [
                    "FHS Opening, Awards & Signings",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzYwMg==",
                "title": "TenX Leadership Talk:  Insights of a CEO’s Journey",
                "categories": [
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTQyMA==",
                "title": "Luxury Fashion Brands in Real Estate: Crafting Spaces of Elegance",
                "categories": [
                    "Branded Residences",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences",
                        "translations": [
                            {
                                "value": "Branded Residences"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA1NjYzMA==",
                "title": "Closing Remarks",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA3MTcyMQ==",
                "title": "Iconic Developments: Navigating the Next Wave of Urban Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjExNTUzOA==",
                "title": "India 2047: The Future of Travel and Hospitality in India​",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjExODIxMA==",
                "title": "Regenerative Tourism: Innovating High-End Hospitality for Tomorrow",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjExOTk5Mg==",
                "title": "TenX Leadership Talk: Leading with Purpose for Sustainable Success",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE2MDE2OA==",
                "title": "From London to Dubai - Perspectives from a Pioneering Developer on the Future of Branded Living in the World's most Dynamic Market for Branded Real Estate",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzA5NjQyNDE=",
        "type": null,
        "firstName": "Philip",
        "lastName": "Barnes",
        "jobTitle": "Chief Executive Officer",
        "organization": "Rotana",
        "photoUrl": "https://static.swapcard.com/public/images/246b45805ccc406aa094b53884a16d4f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzY0OQ==",
                "title": "Leading with Purpose: Commitment to People, Planet and Profit",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzA5NjQ2NzI=",
        "type": null,
        "firstName": "Satya",
        "lastName": "Anand",
        "jobTitle": "President - Europe, Middle East and Africa (EMEA)",
        "organization": "Marriott International",
        "photoUrl": "https://static.swapcard.com/public/images/df441a110429418a9b99f5abd1aca892.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzYxMA==",
                "title": "TenX Leadership Talk: People First for the Future of Hospitality",
                "categories": [
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzYwNw==",
                "title": "Sustainable Hospitality Challenge - The Hospitality Leaders of Tomorrow Reimagining our Industry",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzA5NjQ3Njk=",
        "type": null,
        "firstName": "Paul",
        "lastName": "Griep",
        "jobTitle": "Founder, Sustainable Hospitality Challenge",
        "organization": "Director Industry Relations & Alumni, Hotelschool The Hague",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/e83e40532f97441986d87e699f53d5e6.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAwNQ==",
                "title": "Sustainable Hospitality Challenge - The Hospitality Leaders of Tomorrow Reimagining our Industry",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAzOQ==",
                "title": "Sustainable Hospitality Challenge",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzYwNw==",
                "title": "Sustainable Hospitality Challenge - The Hospitality Leaders of Tomorrow Reimagining our Industry",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzEwMzgxNDk=",
        "type": null,
        "firstName": "Ruben",
        "lastName": "Bruin",
        "jobTitle": "Young Leader",
        "organization": "",
        "photoUrl": "https://static.swapcard.com/public/images/81faa99d8ad74f6fa4cf09cdfdc63bcc.jpeg",
        "speakerOnPlannings": [],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzEwOTE0MjE=",
        "type": "Moderator",
        "firstName": "Amit",
        "lastName": "Nayak, CHA",
        "jobTitle": "Vice President",
        "organization": "HAMA MEA",
        "photoUrl": "https://static.swapcard.com/public/images/1de1fe42566f4d0dbdb24885e0724c4b.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTM2NTM=",
                "title": "The international perspective",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzNDY3NA==",
                "title": "Fireside Chat on Immersive and Decentralized Media Experiences with Web3, Blockchain, AI, and NFTs",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzODIwNw==",
                "title": "HAMA Workshop",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAxMQ==",
                "title": "Strategic Financing of Hospitality Assets: Navigating Uncertainty and Rising Interest Rates for Optimal Funding Solutions",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyOTk0MA==",
                "title": "HAMA Workshop & Annual Debriefing",
                "categories": [
                    "Workshop"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "workshop",
                        "translations": [
                            {
                                "value": "Workshop"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjEzNDk0Mg==",
                "title": "India 2047: Unlocking the Future of Hospitality in a Rising Global Power",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE2MTEwMA==",
                "title": "Visionary Leadership: Driving Abu Dhabi’s Leisure and Entertainment Growth through Immersive Destinations",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Asset Manager",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzExMjQyOTk=",
        "type": "Moderator",
        "firstName": "Dr John",
        "lastName": "Blakey",
        "jobTitle": "Author - Force for Good",
        "organization": "John Blakey Ltd",
        "photoUrl": "https://static.swapcard.com/public/images/3ff173de5e804881833e7614a3bbaa92.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyOTk0NA==",
                "title": "Purpose-Driven Leadership: Practical Tools and Models for Thriving in a Purpose-Driven Agenda",
                "categories": [
                    "ESG & Human Capital",
                    "Workshop"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "workshop",
                        "translations": [
                            {
                                "value": "Workshop"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzY0OQ==",
                "title": "Leading with Purpose: Commitment to People, Planet and Profit",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzEyMTAyNzQ=",
        "type": "Moderator",
        "firstName": "Nick van",
        "lastName": "Marken",
        "jobTitle": "Managing Director",
        "organization": "van Marken Limited",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/ed2db4e72efa4ce59d4a89da87348f17.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTM3MDI=",
                "title": "The risk of reputational damage and owners ROI",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAxNw==",
                "title": "Key Emerging Global Trends Shaping Tourism Development Strategies",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAyNw==",
                "title": "The Evolutionary Journey of Established Hotel Chains in the Face of Change",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTU4NTU0Nw==",
                "title": "Rizwan Kassim in Conversation With Nick Van Marken on What Restaurant Brands and Operators Bring to the Table.  How do They Add Value to a Hotel’s Performance and When Does the Relationship Work Best? What Does He Look for From Potential Partners?",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU1NA==",
                "title": "TenX Leadership Talk: Building Tomorrow's Foundation for the Future of Travel",
                "categories": [
                    "Talks",
                    "Projects & Destinations"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzEyNjQ5Mzc=",
        "type": "Moderator",
        "firstName": "Andrew",
        "lastName": "Sangster",
        "jobTitle": "Editorial Director and Owner",
        "organization": "Hotel Analyst",
        "photoUrl": "https://static.swapcard.com/public/images/179cbe47c45644beaa6f1c683cbc1880.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA0OTQxNQ==",
                "title": "Branded Residences: A New Era in Real Estate Investment",
                "categories": [
                    "Branded Residences",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences",
                        "translations": [
                            {
                                "value": "Branded Residences"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzEyNjcwMzM=",
        "type": "Speaker",
        "firstName": "Aseel  Hussain",
        "lastName": "Bondagjy",
        "jobTitle": "Hotel Talent Development Manager",
        "organization": "NEOM",
        "photoUrl": "https://static.swapcard.com/public/images/7186201b027e4b559da332e0aae95aa3.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzODQ0NQ==",
                "title": "Hospitality Talent Pipeline: From Job to Career - A Think Tank for Developing and Attracting the Best Industry Professionals",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                "title": "FHS Awards - Winner Announcement",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzcyMA==",
                "title": "Company Culture and Relationships as a Competitive Advantage",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzYwNw==",
                "title": "Sustainable Hospitality Challenge - The Hospitality Leaders of Tomorrow Reimagining our Industry",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzEyNjcwNDc=",
        "type": "Speaker",
        "firstName": "Tatiana",
        "lastName": "Labaki",
        "jobTitle": "Director Innovation & Technology at Hotel Division",
        "organization": "NEOM",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/1e221c27233146fb93298f3f88259b27.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAwMg==",
                "title": "Converging Digital Transformation in Hospitality: Cross-Industry Best Practices and Implementation Strategies",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
                "title": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTQwMQ==",
                "title": "Saudi Vision 2030: Reimagining Hospitality",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Saudi Arabia",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-saudi-arabia",
                        "translations": [
                            {
                                "value": "Focus on Saudi Arabia"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzEyOTQzMzg=",
        "type": null,
        "firstName": "Panos",
        "lastName": "Loupasis",
        "jobTitle": "Market Managing Director Türkiye, Middle East & Africa",
        "organization": "Wyndham Hotels & Resorts",
        "photoUrl": "https://static.swapcard.com/public/images/cfcc35a1b06f4109ad5cecfc02afba5a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTM2OTM=",
                "title": "When should owners look at franchising?",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzc0MQ==",
                "title": "The Future of Hospitality Management: From White Label Operators, Franchising, to Traditional Management Agreements",
                "categories": [
                    "Hotelisation of Traditional Assets",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzEzNjAwMzM=",
        "type": "Moderator",
        "firstName": "Tea",
        "lastName": "Ros",
        "jobTitle": "Managing Director",
        "organization": "Strategic Hotel Consulting",
        "photoUrl": "https://static.swapcard.com/public/images/105c65ab7b74493cba3a8c08e4be4172.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg1Ng==",
                "title": "Resilience Strategies: Building Anti-Fragile Hospitality Investments in Resort Destinations",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Europe"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA1MTE4OA==",
                "title": "European Hospitality Revival: Creating Investment Opportunities in Mature Markets",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Europe",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzEzODAzMTk=",
        "type": null,
        "firstName": "Dr. Martin",
        "lastName": "Šoltés",
        "jobTitle": "Chief Executive Officer",
        "organization": "EVUM Motors",
        "photoUrl": "https://static.swapcard.com/public/images/505ed2fdbe6f4f1082e9cd7248e61887.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU1Nw==",
                "title": "Innovations and Trends Shaping the Future of Mobility",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzEzOTM3ODM=",
        "type": "Speaker",
        "firstName": "David",
        "lastName": "Keen",
        "jobTitle": "CEO & Founder",
        "organization": "QUO",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/218657551e024aaab1a1de67504600ab.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzA0Mg==",
                "title": "How will you 'Lead The Change'?",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU4NA==",
                "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – A Strategic Exploration for Hospitality Decision-Makers",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyOTk0Mw==",
                "title": "Forming Culture to Build Brands",
                "categories": [
                    "Workshop"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "workshop",
                        "translations": [
                            {
                                "value": "Workshop"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTQwMQ==",
                "title": "Saudi Vision 2030: Reimagining Hospitality",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Saudi Arabia",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-saudi-arabia",
                        "translations": [
                            {
                                "value": "Focus on Saudi Arabia"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzEzOTM5MjE=",
        "type": null,
        "firstName": "Serena",
        "lastName": "Lim",
        "jobTitle": "Chief Growth Officer",
        "organization": "The Ascott Limited",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/001a18f724f34456972674b28bbe07a1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                "categories": [
                    "Brand & Destination",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTQxOQ==",
                "title": "Serviced Residences Reimagined:  A New Era of Accommodation",
                "categories": [
                    "Projects & Destinations",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE0Mjk3NTc=",
        "type": null,
        "firstName": "Hala Matar",
        "lastName": "Choufany",
        "jobTitle": "President, Middle East & Africa",
        "organization": "HVS",
        "photoUrl": "https://static.swapcard.com/public/images/ff1bc2942014471ca482413fc686ecb4.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTM3MDc=",
                "title": "Arab women driving leadership",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzMjk4OQ==",
                "title": "Building Hotels in a Challenging Environment: Navigating Rising Construction Costs, Funding Delays, and Higher Interest Rates for Hotel Development Projects",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg2OTMyMw==",
                "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – An unbiased Perspective",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzcxNw==",
                "title": "Trailblazing Careers in Hospitality: Leading the Way",
                "categories": [
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE0ODQ4Mzc=",
        "type": "Speaker",
        "firstName": "Markus",
        "lastName": "Schreyer",
        "jobTitle": "Chairman",
        "organization": "META Foundation",
        "photoUrl": "https://static.swapcard.com/public/images/37bd745766e64fc69bfef0b26ba9e3a0.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc1MDU5MA==",
                "title": "Shaping the Kingdom's Destiny: Cultivating Excellence in Hospitality to Shaping Policies and Initiatives that Contribute to Making Hospitality a Great Industry to Work in",
                "categories": [
                    "ESG & Human Capital"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg1NjIzMA==",
                "title": "TenX Leadership Talks: To the Metaverse with Hospitality",
                "categories": [
                    "Talks",
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgxMg==",
                "title": "Digital Transformation - The Future of Design and Customer Experience",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE0ODQ4NTM=",
        "type": null,
        "firstName": "Joe",
        "lastName": "Tabet",
        "jobTitle": "Founder & Managing Director",
        "organization": "JT+Partners",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/92f3ad3bab5d49eebb2b626ffb308ba2.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTg1NjIzMA==",
                "title": "TenX Leadership Talks: To the Metaverse with Hospitality",
                "categories": [
                    "Talks",
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgxMg==",
                "title": "Digital Transformation - The Future of Design and Customer Experience",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE1MTQ4NDk=",
        "type": null,
        "firstName": "Pascal",
        "lastName": "Armoudom",
        "jobTitle": "Partner",
        "organization": "Kearney",
        "photoUrl": "https://static.swapcard.com/public/images/7be19e1298dd4c7ca64f06f4cec210a6.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU2NA==",
                "title": "Net Positive Hospitality: Can Hotels Achieve True Net Positive Hospitality or is it Just a Marketing Ploy",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA4ODI4NA==",
                "title": "Consumer – what are the demands and preferences of the next generation traveler?",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE1NTE1OTg=",
        "type": "Moderator",
        "firstName": "Anthony",
        "lastName": "Lagrabette",
        "jobTitle": "Director - Asset Management , Hotels & Tourism Middle East Region",
        "organization": "CBRE",
        "photoUrl": "https://static.swapcard.com/public/images/3668446eb4cb45ed8ea61d67851b2eb5.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjEyOTQ5Mg==",
                "title": "TenX Leadership Talk: Mastering Growth with an Asset-Light Strategy",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzYxMg==",
                "title": "Global Insights: Aligning Growth Strategies for Asset Owner Success",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE1NTMwNTI=",
        "type": "Speaker",
        "firstName": "Greg",
        "lastName": "O'Stean",
        "jobTitle": "Chief Executive Officer",
        "organization": "United Hospitality Management",
        "photoUrl": "https://static.swapcard.com/public/images/4894f20e103f42a992e91d8d1667f532.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA2ODg2OQ==",
                "title": "Who’s Really in Charge? The Hidden Power of Third Party Management in Hospitality",
                "categories": [
                    "Hotelisation of Traditional Assets",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE1NTMzNzQ=",
        "type": null,
        "firstName": "Adil",
        "lastName": "Jabrayilov",
        "jobTitle": "Development Director MENA",
        "organization": "Louvre Hotels Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/e8db8e58573c4e0ba752101aa67f06b4.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzc0MQ==",
                "title": "The Future of Hospitality Management: From White Label Operators, Franchising, to Traditional Management Agreements",
                "categories": [
                    "Hotelisation of Traditional Assets",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE1ODY5MDI=",
        "type": null,
        "firstName": "Paul",
        "lastName": "Griffiths",
        "jobTitle": "Chief Executive Officer",
        "organization": "Dubai Airports",
        "photoUrl": "https://static.swapcard.com/public/images/5a2b9cf9f3544a5e89a8cbe61d6e9902.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU1NA==",
                "title": "TenX Leadership Talk: Building Tomorrow's Foundation for the Future of Travel",
                "categories": [
                    "Talks",
                    "Projects & Destinations"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE2MTUzMjE=",
        "type": "Speaker",
        "firstName": "Sébastien",
        "lastName": "Bazin",
        "jobTitle": "Group Chairman & CEO",
        "organization": "Accor",
        "photoUrl": "https://static.swapcard.com/public/images/794e920913f5478faf8b9bdb5ace41f3.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzYwMg==",
                "title": "TenX Leadership Talk:  Insights of a CEO’s Journey",
                "categories": [
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE2MTYyMTY=",
        "type": null,
        "firstName": "Gregory",
        "lastName": "Lanter",
        "jobTitle": "CEO Global Development Construction Property",
        "organization": "Club Med - All-Inclusive Beach and Mountain Resorts",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/bd21592bd99c45d3afe4fb5b2ccc5f1c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAwMQ==",
                "title": "Creating Thriving Mixed-Use Developments: The Synergy of Culture, Entertainment and Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc5Mjk5MA==",
                "title": "Splashes of Success: Saudi Arabia's Thriving Leisure Landscape for the Changing Demographics",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA3MzU5MQ==",
                "title": "The Rise of Luxury Hospitality: Trends and Differentiators Shaping the Future of High-End Tourism",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE2MzUxMDk=",
        "type": null,
        "firstName": "Amr",
        "lastName": "El Nady",
        "jobTitle": "Head of Hotels & Hospitality MEA and Managing Director, Global Hotel Desk",
        "organization": "JLL",
        "photoUrl": "https://static.swapcard.com/public/images/982df6695622462cb476e3a7cc2650db.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAxNQ==",
                "title": "Hotel Transactions: Insights for 2023",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg0MjgwMg==",
                "title": "Diversifying the Economy: Strategies for Attracting Foreign Direct Investment and Achieving Vision 2030 Objectives through Innovative Funding Mechanisms",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzY0Nw==",
                "title": "Emergence of Real Estate Investment Trusts in the Middle East",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE2MzUxMTM=",
        "type": null,
        "firstName": "Aboudi",
        "lastName": "Asali",
        "jobTitle": "Executive Vice President, Head of Hotels Advisory MENA",
        "organization": "JLL",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/6bec2df7ac174d53baeb9dbf8656e21c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzc0Mg==",
                "title": "Commercially Driven Asset Management in Hospitality: Strategies for Maximizing Returns",
                "categories": [
                    "Investment & Development",
                    "Hotelisation of Traditional Assets"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE2Nzg2MzY=",
        "type": null,
        "firstName": "Daniel von",
        "lastName": "Barloewen",
        "jobTitle": "Regional Vice President, Accor One Living",
        "organization": "Head of Mixed-Use (EMEA), Global Development Lead, Accor",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/5cf473e2ddec40608d2edc80e017428d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAyNA==",
                "title": "Branded Residential is Booming: Upfront Planning for Making Your Project a Success",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                "categories": [
                    "Brand & Destination",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNw==",
                "title": "Operator Perspective - A Look at How Leading Operators of Branded Residences View their Relationship With Development Partners and Homeowner Communities",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgyMw==",
                "title": "Structuring Rentals Programs to Appeal to Buyers, While Protecting the Interests of Hotel Owners & Developers",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE2OTE5Mjc=",
        "type": null,
        "firstName": "Jeff",
        "lastName": "Tisdall",
        "jobTitle": "Chief Business Officer, Accor One Living",
        "organization": "Global Head of Mixed-Use, Accor",
        "photoUrl": "https://static.swapcard.com/public/images/93e21228749a4f0480a74e05cd7f65e4.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNQ==",
                "title": "Setting the Stage - Introduction to the Branded Residences Forum, Industry Overview, Key Insights, Concepts & Trends",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE0NjM4NA==",
                "title": "Shared Ownership in Dubai and Across Region. Is the Promise of Vacation Ownership, Fractional and Private Residence Clubs about to be Realized?",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE3MDgwOTM=",
        "type": null,
        "firstName": "His Excellency Abdulla bin Touq Al",
        "lastName": "Marri",
        "jobTitle": "Minister of Economy and Chairman of the Tourism Council",
        "organization": "United Arab Emirates",
        "photoUrl": "https://static.swapcard.com/public/images/42ee3cc4823e43319c9ff340311e8e79.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU5MQ==",
                "title": "Leveraging Global Opportunities in Today’s Competitive Business World",
                "categories": [
                    "FHS Opening, Awards & Signings",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE3MDgxMTc=",
        "type": null,
        "firstName": "Guy",
        "lastName": "Hutchinson",
        "jobTitle": "President, Middle East & Africa",
        "organization": "Hilton",
        "photoUrl": "https://static.swapcard.com/public/images/7b69152893044de9bd64e3bd51d49861.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc1MDU3OQ==",
                "title": "Investing in Saudi Arabia: A Blueprint for Successful Market Entry and Investment",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzY0OQ==",
                "title": "Leading with Purpose: Commitment to People, Planet and Profit",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE3MDgxOTY=",
        "type": null,
        "firstName": "Ana Lobo",
        "lastName": "Martins",
        "jobTitle": "Director, Interior Design",
        "organization": "ARC International Design Consultants",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/dd57025983104c75946e38dee4bbbd46.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgyMDAxNw==",
                "title": "Creating and Reinventing Destinations: From Conception to Cultivation",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA1MTE5OQ==",
                "title": "New Horizons Ahead: Trends and Developments in Tomorrow’s Designs",
                "categories": [
                    "Projects & Destinations",
                    "Green Construction & Smart Cities",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "green-construction-and-smart-cities",
                        "translations": [
                            {
                                "value": "Green Construction & Smart Cities"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE3MDgzMDM=",
        "type": null,
        "firstName": "Carlos",
        "lastName": "Khneisser",
        "jobTitle": "Vice President Development Middle East & Africa",
        "organization": "Hilton",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/fd2d5fa65f704f1896360c6fd505e0ab.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk4Ng==",
                "title": "Building Sustainable Hospitality: Setting the Scene for Hotel Development in the Middle East",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU1MQ==",
                "title": "Emerging Lifestyle Brands: Bridging Luxury and Midscale Markets with Locally Inspired Experiences in New and Established Destinations",
                "categories": [
                    "Projects & Destinations",
                    "Branding Strategies"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3MzE3Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branding-strategies",
                        "translations": [
                            {
                                "value": "Branding Strategies"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE3MjExMjg=",
        "type": null,
        "firstName": "Elie",
        "lastName": "Younes",
        "jobTitle": "Executive Vice President & Global Chief Development Officer",
        "organization": "Radisson Hotel Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d1152a46d0c3455b9e8e29b6c2a9a52c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjExOTk5Mg==",
                "title": "TenX Leadership Talk: Leading with Purpose for Sustainable Success",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE3NDAzMzY=",
        "type": "Moderator",
        "firstName": "Louis",
        "lastName": "Abboud",
        "jobTitle": "Chief Development Officer, Deputy Head MEAT & Global Head F&B Development",
        "organization": "Ennismore",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/fc5fda656ea943b2ac6c1d865715584a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgwOTM2NA==",
                "title": "How Lifestyle Hotel and F&B Brands are Disrupting the Future of Hospitality in the Kingdom",
                "categories": [
                    "Brand & Destination",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNg==",
                "title": "Unpacking the Benefits of Branded Residences for Investors",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE3OTQzNjc=",
        "type": null,
        "firstName": "Fouad",
        "lastName": "Talaat",
        "jobTitle": "Regional Manager Middle East & Africa",
        "organization": "Booking.com",
        "photoUrl": "https://static.swapcard.com/public/images/08008a8ab5a8401a8a4aed9cc5a7be31.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA4ODY3OQ==",
                "title": "From Search to Stay: Enhancing Booking Tech for a Seamless Guest Journey",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE3OTgwMjA=",
        "type": null,
        "firstName": "Paul",
        "lastName": "Bridger",
        "jobTitle": "Chief Operating Officer",
        "organization": "Rove Hotels",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/c3ee50cc462e49ac86d1a8a097a15de2.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzA0Nw==",
                "title": "Exploring Profitable Horizons: Assessing Investment in the Booming Lifestyle Midmarket Hotel Segment",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                "categories": [
                    "Brand & Destination",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTQxNQ==",
                "title": "Branded Residences: A New Era in Real Estate Investment",
                "categories": [
                    "Branded Residences",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences",
                        "translations": [
                            {
                                "value": "Branded Residences"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4MzM5NDQ=",
        "type": null,
        "firstName": "JS",
        "lastName": "Anand",
        "jobTitle": "Founder & CEO",
        "organization": "Leva Hotels",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/0f77c61aeb96470ba1a89680e273a473.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzA0Nw==",
                "title": "Exploring Profitable Horizons: Assessing Investment in the Booming Lifestyle Midmarket Hotel Segment",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc5ODQ4OQ==",
                "title": "A New Dawn: Pioneering the Rise of Lifestyle Hospitality Brands in Africa's Urban and Leisure Destinations",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzczNg==",
                "title": "Insights into Africa's Dynamic Investment Landscape",
                "categories": [
                    "Focus on Africa",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NDUxMDQ=",
        "type": "Moderator",
        "firstName": "Riyan",
        "lastName": "Itani",
        "jobTitle": "Founder",
        "organization": "Global Branded Residences",
        "photoUrl": "https://static.swapcard.com/public/images/0a8fedf8c19444388ccf07bf5208b2c7.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgyMg==",
                "title": "Future Telling – What Shapes and Forms will Branded Residences Take in Coming Years",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NDc2MDA=",
        "type": null,
        "firstName": "Artur",
        "lastName": "Gerber",
        "jobTitle": "Chief Executive Officer",
        "organization": "TUI BLUE Hotels & Resorts",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/0f23ecf59ba442a396d3bcf6966bbcfe.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgyOTY2OQ==",
                "title": "What’s whetting Investors’ Appetite for Resorts?",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzY0OQ==",
                "title": "Leading with Purpose: Commitment to People, Planet and Profit",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NDc2MTE=",
        "type": null,
        "firstName": "Wesam",
        "lastName": "Okasha",
        "jobTitle": "Head of Global Development",
        "organization": "TUI BLUE Hotels & Resorts",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/68a00e0418ad48b29ede5f0a5290d527.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc4MzQ3Ng==",
                "title": "Guests' Quest for Unique Experiences: The African Approach to Authentic Leisure",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzczOA==",
                "title": "Guests' Quest for Unique Experiences: The African Approach to Authentic Leisure",
                "categories": [
                    "Focus on Africa"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NDkwMDM=",
        "type": null,
        "firstName": "Adrian",
        "lastName": "Strittmatter",
        "jobTitle": "Chief Executive Officer",
        "organization": "Saentys",
        "photoUrl": "https://static.swapcard.com/public/images/e85beecfcc9645db9b251cb36856562f.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxOQ==",
                "title": "Marketing Case Studies - Short Presentations by Leading Marketing Professionals Who Have Helped Drive the Success of Branded Residence Projects",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NDkxODM=",
        "type": "Moderator",
        "firstName": "Ali",
        "lastName": "Manzoor",
        "jobTitle": "Senior Director Head of Hospitality, Hotels & Tourism",
        "organization": "CBRE MENA",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/ee75f5da2004484ebe7a16782b1cd54b.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk5Nw==",
                "title": "Hospitality Development in Saudi Arabia: Transforming our World - Vision 2030",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgyMDAxNA==",
                "title": "Travelling for Good: Innovations in Luxury Travel for Responsible Tourism Development",
                "categories": [
                    "ESG & Human Capital"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNw==",
                "title": "Operator Perspective - A Look at How Leading Operators of Branded Residences View their Relationship With Development Partners and Homeowner Communities",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NDkxOTQ=",
        "type": "Speaker",
        "firstName": "Inge",
        "lastName": "Huijbrechts",
        "jobTitle": "Chief Sustainability & Security Officer",
        "organization": "Radisson Hotel Group",
        "photoUrl": "https://static.swapcard.com/public/images/3fff1ec9abff4f11927c504ea2edd3fd.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU2NA==",
                "title": "Net Positive Hospitality: Can Hotels Achieve True Net Positive Hospitality or is it Just a Marketing Ploy",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NDkyMzI=",
        "type": null,
        "firstName": "Dr. Marinos",
        "lastName": "Giannopoulos",
        "jobTitle": "Chief Executive Officer",
        "organization": "Enterprise Greece",
        "photoUrl": "https://static.swapcard.com/public/images/990ab432c6654c4a890c36aaff1455f2.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA1MTE4OA==",
                "title": "European Hospitality Revival: Creating Investment Opportunities in Mature Markets",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Europe",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NDk3Njc=",
        "type": null,
        "firstName": "Charbel",
        "lastName": "Boutros",
        "jobTitle": "VP Development MEA",
        "organization": "IHG Hotels & Resorts",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/60072b9b11384997844faa8e0428849d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk4Ng==",
                "title": "Building Sustainable Hospitality: Setting the Scene for Hotel Development in the Middle East",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU4NA==",
                "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – A Strategic Exploration for Hospitality Decision-Makers",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU1MQ==",
                "title": "Emerging Lifestyle Brands: Bridging Luxury and Midscale Markets with Locally Inspired Experiences in New and Established Destinations",
                "categories": [
                    "Projects & Destinations",
                    "Branding Strategies"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3MzE3Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branding-strategies",
                        "translations": [
                            {
                                "value": "Branding Strategies"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NDk3ODA=",
        "type": "Speaker",
        "firstName": "Haitham",
        "lastName": "Mattar",
        "jobTitle": "Special Advisor, UN Tourism",
        "organization": "Managing Director MEA & South West Asia, IHG Hotels & Resorts",
        "photoUrl": "https://static.swapcard.com/public/images/435cebd48c194e0fb2ae286d35e8a0e0.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzA0OQ==",
                "title": "Tourism-Led Policies for a Better World: The Importance of the Industry Getting a Seat at the Government Policy-making Table",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAzOQ==",
                "title": "Sustainable Hospitality Challenge",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU3OQ==",
                "title": "Investing in Saudi Arabia: A Blueprint for Successful Market Entry and Investment",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTkwMTQ2Mw==",
                "title": "Fireside Chat: How to Align Tourism Strategies Across Key African Markets for Sustainable Growth",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjEwNzQ0NA==",
                "title": "A Global Perspective: UN Tourism's Role in Addressing Sustainable Growth in Travel",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NDk5Mzg=",
        "type": "Speaker",
        "firstName": "Pier Paolo",
        "lastName": "Righi",
        "jobTitle": "CEO & President",
        "organization": "Karl Lagerfeld",
        "photoUrl": "https://static.swapcard.com/public/images/79c118f294c24c3b90c2504e9ba9b93b.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA0OTQyMA==",
                "title": "Luxury Fashion Brands in Real Estate: Crafting Spaces of Elegance",
                "categories": [
                    "Branded Residences",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences",
                        "translations": [
                            {
                                "value": "Branded Residences"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgyMg==",
                "title": "Future Telling – What Shapes and Forms will Branded Residences Take in Coming Years",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NTAyOTI=",
        "type": "Moderator",
        "firstName": "Rico",
        "lastName": "Picenoni",
        "jobTitle": "Head of Global Residential Development Consultancy",
        "organization": "Savills",
        "photoUrl": "https://static.swapcard.com/public/images/b0a1c9d0c3b24b52b91cb27bd540cb8c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgyMw==",
                "title": "Structuring Rentals Programs to Appeal to Buyers, While Protecting the Interests of Hotel Owners & Developers",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Real Estate Agent/Surveyor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NTAzMTc=",
        "type": null,
        "firstName": "Gustavo De",
        "lastName": "Hostos",
        "jobTitle": "Founder & Managing Partner",
        "organization": "Forsite Creative",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/7f3d496d1fa84a62b29c020bff30bed5.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAyMg==",
                "title": "Tapping into New F&B Data for Hotels and How it Can Drive Strategy for Decision Making",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg1MDk1Ng==",
                "title": "GRIF Data Report - Using Data to Competition Proof your Business and Invest in the Right Places",
                "categories": [
                    "Restaurant Investment",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg3OQ==",
                "title": "Driving strategic decisions making for hotels through bespoke F&B data",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE0OTk3OA==",
                "title": "Masterplanning Hotels: Driving Strategic Decisions through Sentiment Data",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NTA1NDQ=",
        "type": "Moderator",
        "firstName": "Paul",
        "lastName": "Rands",
        "jobTitle": "Managing Director",
        "organization": "Future of Hospitality Institute",
        "photoUrl": "https://static.swapcard.com/public/images/7cefd223526446a39cd9fc92d3c167c2.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1Ng==",
                "title": "Strategies to Drive the Development and Operation of Sustainable Homeowner Communities that Deliver on Health and Wellbeing Objectives",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NTA3MDU=",
        "type": null,
        "firstName": "Andreas",
        "lastName": "Löcher",
        "jobTitle": "Head of Investment Management Operational (Hotel / Retail)",
        "organization": "Union Investment Real Estate",
        "photoUrl": "https://static.swapcard.com/public/images/38d68d99909c48898f4088053b8a3ee6.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU5OA==",
                "title": "Capital Talks: Global Investment and the Allure of the Hospitality Industry",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NTA5Mjk=",
        "type": null,
        "firstName": "Turab",
        "lastName": "Saleem",
        "jobTitle": "Partner - Hospitality,Tourism & Leisure Advisory Services  - MENA",
        "organization": "Knight Frank",
        "photoUrl": "https://static.swapcard.com/public/images/2997ea6051bc4a76af56a4500fbc22be.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAzNQ==",
                "title": "Branded Residences: Value Addition to Hospitality Offerings",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMjk4MA==",
                "title": "The Evolution of Beach Clubs: A New Era for Hospitality Investments – Leveraging Brands to Create Real Estate and Bringing in Operators to Drive Revenue - Located at Cafe Del Mar",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAzNA==",
                "title": "F&B Concepts Tour (McCafferty's, Central, Art Market, Cafe del Mar)",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTc5MjI0Ng==",
                "title": "Digital Talks: The Hotel of the Future",
                "categories": [
                    "Talks",
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc4ODc4Nw==",
                "title": "The Key to Successful Hospitality Project Development in Saudi Arabia",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc4MzQzOQ==",
                "title": "Crafting Success: A Comprehensive Journey through Hotel Project Development in Africa",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA1MTE5Nw==",
                "title": "The Hotel of the Future",
                "categories": [
                    "Projects & Destinations",
                    "Sustainability & Innovation",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NTA5OTA=",
        "type": "Moderator",
        "firstName": "Adeline",
        "lastName": "Phua",
        "jobTitle": "Managing Lyf Partner",
        "organization": "The Ascott Limited",
        "photoUrl": "https://static.swapcard.com/public/images/dade4e07b5e3468986d2892903f86f84.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzcyNw==",
                "title": "Capitalizing on the Alternative Accommodation Boom: Unveiling Realities and Global Trends",
                "categories": [
                    "Projects & Destinations",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NTEwMDQ=",
        "type": "Moderator",
        "firstName": "Dr. Bertrand",
        "lastName": "Audrin",
        "jobTitle": "Professor",
        "organization": "EHL Hospitality Business School",
        "photoUrl": "https://static.swapcard.com/public/images/297ae5e757984e778f1c8eb9c88d5be1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzcyMA==",
                "title": "Company Culture and Relationships as a Competitive Advantage",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NTEwMzY=",
        "type": null,
        "firstName": "Dr. Sowon",
        "lastName": "Kim",
        "jobTitle": "Professor",
        "organization": "EHL Hospitality Business School",
        "photoUrl": "https://static.swapcard.com/public/images/d94470602c304c16b06f8e87c856b51b.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyOTk0MQ==",
                "title": "Unveiling the Invisible: Women and Implicit Bias in Leadership.",
                "categories": [
                    "ESG & Human Capital",
                    "Workshop",
                    "Women Leadership"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "workshop",
                        "translations": [
                            {
                                "value": "Workshop"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3MzE2NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "women-leadership",
                        "translations": [
                            {
                                "value": "Women Leadership"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NTcyMzg=",
        "type": "Moderator",
        "firstName": "Lara Y.",
        "lastName": "Barrett",
        "jobTitle": "Senior Vice President Legal - Luxury & Lifestyle, Special Projects & Global Legal Lead for Accor One Living",
        "organization": "Accor",
        "photoUrl": "https://static.swapcard.com/public/images/620ae55a06b64822af6ba7d9b8dc5a7e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgyNA==",
                "title": "Legal Structures: Protecting Interests of Investors, Purchasers & Brands",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NTg5NTY=",
        "type": null,
        "firstName": "Scott",
        "lastName": "Antel",
        "jobTitle": "Founder & Owner",
        "organization": "Scotts FZ LLE",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/750373591fb945a3b6ee3e909a226df6.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAyNA==",
                "title": "Branded Residential is Booming: Upfront Planning for Making Your Project a Success",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMjk5Mw==",
                "title": "Turning the Tables: Hard Talk of Stephen Sackur on his view of Global Journalism in a Changing World",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                "categories": [
                    "Brand & Destination",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTkwMjE5NQ==",
                "title": "Management Agreements and Franchise Models as Viable Strategies in Emerging Markets?",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgyNA==",
                "title": "Legal Structures: Protecting Interests of Investors, Purchasers & Brands",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Lawyer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4NzU5OTM=",
        "type": "Moderator",
        "firstName": "Trevor",
        "lastName": "Ward",
        "jobTitle": "Managing Director",
        "organization": "W Hospitality Group",
        "photoUrl": "https://static.swapcard.com/public/images/94fe4da369f145cd81e9ae1d492a7167.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTI2MTg=",
                "title": "Regional Focus - Anglophone West Africa",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTc4MzQzOA==",
                "title": "In the Pipeline",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzczMw==",
                "title": "Shaping Tomorrow: What’s in the Pipeline for Africa's Booming Hospitality Market",
                "categories": [
                    "Focus on Africa"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzczOA==",
                "title": "Guests' Quest for Unique Experiences: The African Approach to Authentic Leisure",
                "categories": [
                    "Focus on Africa"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4ODA3ODI=",
        "type": null,
        "firstName": "Richard",
        "lastName": "Williamson",
        "jobTitle": "Chief Operating Officer",
        "organization": "Considerate Group",
        "photoUrl": "https://static.swapcard.com/public/images/4bbae35ad27d473a9510a393ab25dfd0.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgwOTM2MA==",
                "title": "Sustainable Horizons: Catalyzing Change Through Green Investments",
                "categories": [
                    "ESG & Human Capital",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU2MQ==",
                "title": "Decarbonisation and the Pathway to Net Zero – Start with the Data!",
                "categories": [
                    "Green Construction & Smart Cities",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "green-construction-and-smart-cities",
                        "translations": [
                            {
                                "value": "Green Construction & Smart Cities"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4ODY0MjI=",
        "type": "Speaker",
        "firstName": "Jameel",
        "lastName": "Verjee",
        "jobTitle": "Founder & CEO",
        "organization": "CityBlue Hotels (a member of The Diar Group)",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/e2adba32211f40e5a5ed4440d0efb97f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTkwMTU3OA==",
                "title": "Hospitality with Purpose: Balancing Profitability with ESG and Culture",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzczOA==",
                "title": "Guests' Quest for Unique Experiences: The African Approach to Authentic Leisure",
                "categories": [
                    "Focus on Africa"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4OTkxNzQ=",
        "type": null,
        "firstName": "Giuliano",
        "lastName": "Gasparini, FRICS, CRE, HAMA, IoH, CHIA",
        "jobTitle": "Head of Hospitality Asset Management",
        "organization": "WASL Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/1185b82f30fb4c59b01dd92aafdcf851.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc4MjkzMg==",
                "title": "USALI 11th Edition – Tips and Tricks",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0NDk4Nw==",
                "title": "The New USALI 12th Edition: What To Expect",
                "categories": [
                    "Workshop"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "workshop",
                        "translations": [
                            {
                                "value": "Workshop"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTU0Nw==",
                "title": "Greening Hospitality: When ESG Law Compliance Impacts Your Hotel Real Estate Value",
                "categories": [
                    "Green Construction & Smart Cities",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "green-construction-and-smart-cities",
                        "translations": [
                            {
                                "value": "Green Construction & Smart Cities"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE4OTkxODM=",
        "type": "Moderator",
        "firstName": "Gemma",
        "lastName": "Greenwood",
        "jobTitle": "Director",
        "organization": "Content Inc",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/28f93f5e7809429484223268fc818522.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAyOQ==",
                "title": "The Opportunity for Luxury Brand and Hotel Partnerships: Exploring Demand Trends and Collaboration Success Factors",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAxOA==",
                "title": "Welcome to FHS Intelligence Talks",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTU4MDc0OQ==",
                "title": "Women Belong in the Kitchen: Pursuing Gender Equity in the Culinary World",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTU4MDc0OA==",
                "title": "Closing Remarks",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU3NQ==",
                "title": "Welcome Back",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA4ODY3OQ==",
                "title": "From Search to Stay: Enhancing Booking Tech for a Seamless Guest Journey",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE5MDU0NzY=",
        "type": "Moderator",
        "firstName": "Son-Trang",
        "lastName": "Nguyen",
        "jobTitle": "Production Manager",
        "organization": "The Bench",
        "photoUrl": "https://static.swapcard.com/public/images/1e4aa41125474fa99b31b1e8170ab3a0.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                "title": "Start-Up Den",
                "categories": [
                    "Startup Den"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "startup-den",
                        "translations": [
                            {
                                "value": "Startup Den"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NA==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Competitions"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "competitions",
                        "translations": [
                            {
                                "value": "Competitions"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NQ==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE5Mzg2NDM=",
        "type": null,
        "firstName": "Andrea",
        "lastName": "Delfini",
        "jobTitle": "Founder & CEO",
        "organization": "Blastness",
        "photoUrl": "https://static.swapcard.com/public/images/3833becbe7314934b891b5dcb70b2cab.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA0OTU1Mg==",
                "title": "Invest in Italy:  Showcasing Unique Hospitality Projects",
                "categories": [
                    "Investment & Development",
                    "Projects & Destinations",
                    "Focus on Europe"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE5Mzg2NDk=",
        "type": null,
        "firstName": "Piergiorgio",
        "lastName": "Schirru",
        "jobTitle": "Executive Vice President",
        "organization": "Blastness",
        "photoUrl": "https://static.swapcard.com/public/images/a06d22a0a9b1476eb024ee304c8ac0e1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA4ODY3OQ==",
                "title": "From Search to Stay: Enhancing Booking Tech for a Seamless Guest Journey",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE5Mzg4MDg=",
        "type": "Moderator",
        "firstName": "James",
        "lastName": "Hacon",
        "jobTitle": "Founding Partner",
        "organization": "Think Hospitality",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/44ab6f5238b9455ea55791f45685aab1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk4Mg==",
                "title": "The Impact of Third-Party Outlets on Hotel Revenue and Real Estate Value – What are the Keys to Choosing the Right Operator, Concept and Agreement?",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5NDIzNA==",
                "title": "Four Levers of Revenue Optimisation for Restaurants and Hotel F&B, with Practical Advice on Maximising Sales and Profitability",
                "categories": [
                    "Restaurant Investment",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5NDQ4OQ==",
                "title": "Founder Chat: In conversation with  Ashish Tulsian on understanding how to leverage  AI & Power of data for your restaurant business",
                "categories": [
                    "Restaurant Investment",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5NDI0MQ==",
                "title": "Lessons learned from tough times – opening in challenging markets and what tactics you can employ to overcome the hurdles",
                "categories": [
                    "Restaurant Investment",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5NDI0Ng==",
                "title": "The future of investment into Saudi F&B – what are the emerging vehicles and opportunities to bring investment into the market?",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU1OQ==",
                "title": "The World's First AI-Created Restaurant",
                "categories": [
                    "Restaurant Investment",
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Mg==",
                "title": "The World's First AI-Created Restaurant Revealed",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4MA==",
                "title": "Hoteliers Are From Mars, Restauranters Are From Venus: Why Hoteliers Can’t Run Restaurants?",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE0NzcxNg==",
                "title": "The World's First AI-Created Restaurant In Action",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE5Mzg4MTQ=",
        "type": null,
        "firstName": "Bani",
        "lastName": "Haddad",
        "jobTitle": "Founder & Managing Director",
        "organization": "Aleph Hospitality",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/4a639b6d658c48fd9b806f450f012908.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgyOTY4MA==",
                "title": "Assessing the Significance and Economic Viability of International Brands in African Destinations",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzc0MQ==",
                "title": "The Future of Hospitality Management: From White Label Operators, Franchising, to Traditional Management Agreements",
                "categories": [
                    "Hotelisation of Traditional Assets",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE5Mzg4MTc=",
        "type": null,
        "firstName": "Ben",
        "lastName": "Edwards",
        "jobTitle": "Group Head of Cost, Commercial, and Procurement",
        "organization": "Red Sea Global",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/ad11f8c77ccf4d0dbd9386316aa311ca.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTg1Nzg1MA==",
                "title": "Your Path to Red Sea Global: Exploring Projects and Partnership Opportunities",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyOTkzOQ==",
                "title": "Your Path to Red Sea Global: Exploring Projects and Partnership Opportunities",
                "categories": [
                    "Investment & Development",
                    "Workshop"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "workshop",
                        "translations": [
                            {
                                "value": "Workshop"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE5Mzg4MjE=",
        "type": null,
        "firstName": "Mohammed Al",
        "lastName": "Fardan",
        "jobTitle": "Head of Procurement",
        "organization": "Red Sea Global",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/8a218f4b221941a8909ff30a522f2622.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyOTkzOQ==",
                "title": "Your Path to Red Sea Global: Exploring Projects and Partnership Opportunities",
                "categories": [
                    "Investment & Development",
                    "Workshop"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "workshop",
                        "translations": [
                            {
                                "value": "Workshop"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE5NTk1NTg=",
        "type": null,
        "firstName": "Aradhana",
        "lastName": "Khowala",
        "jobTitle": "CEO & Founder",
        "organization": "Aptamind Partners",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/1db9674ed24c4de5807e41f7e15ac1f1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc5MjI0NQ==",
                "title": "Data Talks: The Future of Wellness - New Data on Wellness Travel",
                "categories": [
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU4Mw==",
                "title": "TenX Leadership Talks: The Longevity Revolution and what the 100-year Life means for You and the Future of Hospitality",
                "categories": [
                    "ESG & Human Capital",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgyOTY5MA==",
                "title": "The Urbanisation and changing Demographics in Africa and how it will shape the Future of Humanity",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNjc3Mg==",
                "title": "From Boom to Doom and Gloom – Overtourism’s Deja Woes",
                "categories": [
                    "Projects & Destinations"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzE5OTQ2OTU=",
        "type": null,
        "firstName": "David",
        "lastName": "Vely",
        "jobTitle": "Vice President Development, Middle East, Africa & India",
        "organization": "Club Med",
        "photoUrl": "https://static.swapcard.com/public/images/c2def37338cb4afd81b19bba1e6f162f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc4MzQ3Ng==",
                "title": "Guests' Quest for Unique Experiences: The African Approach to Authentic Leisure",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg1Ng==",
                "title": "Resilience Strategies: Building Anti-Fragile Hospitality Investments in Resort Destinations",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Europe"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIwMTEzNjU=",
        "type": null,
        "firstName": "Paolo",
        "lastName": "Barletta",
        "jobTitle": "Chief Executive Officer",
        "organization": "Arsenale Spa",
        "photoUrl": "https://static.swapcard.com/public/images/61770aec30614dc1a1c0d6d79e6229fe.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA0OTU1Mg==",
                "title": "Invest in Italy:  Showcasing Unique Hospitality Projects",
                "categories": [
                    "Investment & Development",
                    "Projects & Destinations",
                    "Focus on Europe"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIwMjg2Nzg=",
        "type": null,
        "firstName": "Rizwan",
        "lastName": "Kassim",
        "jobTitle": "Founder & Managing Partner",
        "organization": "RIKAS Hospitality Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/bfd98485cb0646bfba84fdb2f7c29cfd.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgwOTM2NA==",
                "title": "How Lifestyle Hotel and F&B Brands are Disrupting the Future of Hospitality in the Kingdom",
                "categories": [
                    "Brand & Destination",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4NA==",
                "title": "Unlocking F&B Success: Boosting Hotel Real Estate Value with Effective Third-Party Outlet Agreements",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAzNTg1Mw==",
                "title": "FHS Awards 2024",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIwMjkxNjI=",
        "type": null,
        "firstName": "Jean-Baptiste",
        "lastName": "Recher",
        "jobTitle": "Regional VP Development Luxury Brands MEAT",
        "organization": "Accor",
        "photoUrl": "https://static.swapcard.com/public/images/b7599a092b6942bc85b0e47624e17766.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1Nw==",
                "title": "Making Standalones Work - Bringing the Brand to Life in the Absence of a Co-Located Hotel",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIwNDIzNDA=",
        "type": "Speaker",
        "firstName": "Naiara",
        "lastName": "Lopez Giner",
        "jobTitle": "Tourism Advisory Lead",
        "organization": "Colliers MENA",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/c06a42b2a6874de0bb036958e605041b.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTkzMDA5NA==",
                "title": "Workshop - Decoding Investment Opportunities in African Tourism Destinations",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU1MA==",
                "title": "RevoluationAIsing Tourism",
                "categories": [
                    "Techology & AI",
                    "Intelligence Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0ODk4Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "intelligence-talks",
                        "translations": [
                            {
                                "value": "Intelligence Talks"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIwNDIzNDI=",
        "type": "Moderator",
        "firstName": "Nicolas",
        "lastName": "Nasra",
        "jobTitle": "Director - Head of Hotel Advisory",
        "organization": "Colliers MENA",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/2107edc501364b20835b2031eb656fc5.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzA0Nw==",
                "title": "Exploring Profitable Horizons: Assessing Investment in the Booming Lifestyle Midmarket Hotel Segment",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
                "title": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc5Mjk1Nw==",
                "title": "The Power of AI in Hospitality: Practical Solutions for Investors",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgxMQ==",
                "title": "Disrupting the Market: How AI in the Hospitality Industry Is Changing the Game?",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIwNDIzODE=",
        "type": "Judge",
        "firstName": "Maya",
        "lastName": "Ayoub",
        "jobTitle": "Founder & CEO",
        "organization": "District-Twelve",
        "photoUrl": "https://static.swapcard.com/public/images/350451e42a844bb388b4c7f2d3833df2.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NQ==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NA==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Competitions"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "competitions",
                        "translations": [
                            {
                                "value": "Competitions"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Judge",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIwOTg2MDk=",
        "type": null,
        "firstName": "Dale Qi",
        "lastName": "Shen, MRICS",
        "jobTitle": "Vice President, Director - Real Estate Structuring & Advisory",
        "organization": "Mashreq Bank",
        "photoUrl": "https://static.swapcard.com/public/images/cade34b84234410ca850597be8b11d09.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTU1ODcxNw==",
                "title": "Financing Hospitality Assets and Key Considerations in UAE",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTU0Nw==",
                "title": "Greening Hospitality: When ESG Law Compliance Impacts Your Hotel Real Estate Value",
                "categories": [
                    "Green Construction & Smart Cities",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "green-construction-and-smart-cities",
                        "translations": [
                            {
                                "value": "Green Construction & Smart Cities"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMTM5MzA=",
        "type": null,
        "firstName": "Sara",
        "lastName": "Codner",
        "jobTitle": "Area Director Spa & Wellness",
        "organization": "Mandarin Oriental Hotel Group",
        "photoUrl": "https://static.swapcard.com/public/images/a06c02fcad8742e99e49c940ee7511d4.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk2MQ==",
                "title": "The Future of Wellness: Brand Challenges and Opportunities",
                "categories": [
                    "Wellness & Medical Tourism"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU4Nzc2OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "wellness-and-medical-tourism",
                        "translations": [
                            {
                                "value": "Wellness & Medical Tourism"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMTgzODg=",
        "type": null,
        "firstName": "Marina",
        "lastName": "Franolic",
        "jobTitle": "Head of Investors Relations",
        "organization": "The Bench",
        "photoUrl": "https://static.swapcard.com/public/images/3abe13fde6ed44b3882a207e2728ca63.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTg5MzkyNw==",
                "title": "Welcome to the Future",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA1OTMwNg==",
                "title": "Welcome Remarks",
                "categories": [
                    "Focus on Europe"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMTg5Nzk=",
        "type": "Moderator",
        "firstName": "Fritz",
        "lastName": "Dickamp",
        "jobTitle": "Managing Director",
        "organization": "Studio 49",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/2036c6d15c0647e4ad00d055e433e9be.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk5MQ==",
                "title": "Embracing the Era of the Digital Traveler: Transforming Hotel Operations for the Future",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzA0Mg==",
                "title": "How will you 'Lead The Change'?",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTU3NjUxNw==",
                "title": "EAHM Leadership Series - Creating Harmony: Aligning People, Planet, and Future Growth in Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc5MjI0NA==",
                "title": "Welcome to the Data Talks",
                "categories": [
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5MDk1Nw==",
                "title": "Welcome to the Digital Talks",
                "categories": [
                    "Talks",
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTQxOA==",
                "title": "Cyber Resilience in Hospitality: Future-proofing your Data",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgwNw==",
                "title": "Back to Basics: Addressing Key Bottlenecks in Hospitality Innovation Before Advancing to Advanced Technologies",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Media",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMTkyNDU=",
        "type": null,
        "firstName": "Nada",
        "lastName": "Serhir",
        "jobTitle": "Tourism Investment Maketing Department Head",
        "organization": "The Moroccan Agency for Tourism Development (SMIT)",
        "photoUrl": "https://static.swapcard.com/public/images/547c4cf2a4684accaf92740cf0470983.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAzMw==",
                "title": "Morocco's New Tourism Roadmap: Unveiling new Investment Projects",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTU0OA==",
                "title": "Invest in Morocco:  Showcasing Unique Hospitality Projects",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Africa",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMTkyODQ=",
        "type": "Judge",
        "firstName": "Jonathan",
        "lastName": "Worsley",
        "jobTitle": "Chairman & CEO",
        "organization": "The Bench",
        "photoUrl": "https://static.swapcard.com/public/images/17a7878fe072462dbdfaa73230f5d186.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                "title": "FHS Awards - Winner Announcement",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                "title": "Closing Remarks",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                "categories": [
                    "Culture & Heritage",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "heritage-and-tourism",
                        "translations": [
                            {
                                "value": "Culture & Heritage"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                "title": "Welcome Remarks",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                "title": "Let's meet the Future with Desi",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                "title": "Start-Up Den",
                "categories": [
                    "Startup Den"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "startup-den",
                        "translations": [
                            {
                                "value": "Startup Den"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NA==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Competitions"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "competitions",
                        "translations": [
                            {
                                "value": "Competitions"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU1Mw==",
                "title": "Official Opening FHS World 2024",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU3NQ==",
                "title": "Welcome Back",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU2MA==",
                "title": "The Future Growth of Tourism in Dubai: Harnessing Innovation, Sustainability, Accessibility and Leadership",
                "categories": [
                    "Projects & Destinations",
                    "Green Construction & Smart Cities",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "green-construction-and-smart-cities",
                        "translations": [
                            {
                                "value": "Green Construction & Smart Cities"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA1NjYzMA==",
                "title": "Closing Remarks",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzYxMA==",
                "title": "TenX Leadership Talk: People First for the Future of Hospitality",
                "categories": [
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAzMDE5NA==",
                "title": "Welcome to the Branded Residences Forum",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAzNTg1Mw==",
                "title": "FHS Awards 2024",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Judge",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMTk0MzQ=",
        "type": null,
        "firstName": "Ali",
        "lastName": "Shahid",
        "jobTitle": "Marketing Director",
        "organization": "The Bench",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/bd0dbdf1442141679c3df8de64b62560.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAxMg==",
                "title": "Morning Run",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzA0MQ==",
                "title": "Morning Run",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzA0Mg==",
                "title": "How will you 'Lead The Change'?",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTYwODMyNA==",
                "title": "Announcements & Signing Ceremonies",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgyMDAyMQ==",
                "title": "Beyond the Hype - A Practical Insight into AI and the Future of Business",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgwOTM2Mw==",
                "title": "Fireside Chat with Desdemona The Robot",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA1NjYzNw==",
                "title": "Beyond the AI Hype - An Interactive Workshop with Practical Problem Solving Demos",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMjAzOTc=",
        "type": null,
        "firstName": "Kevin",
        "lastName": "Goh",
        "jobTitle": "Chief Executive Officer",
        "organization": "The Ascott Limited",
        "photoUrl": "https://static.swapcard.com/public/images/c605ef87a3bb480e97ce2b91a2946d3f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjEyOTQ5Mg==",
                "title": "TenX Leadership Talk: Mastering Growth with an Asset-Light Strategy",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMjA0Mjk=",
        "type": null,
        "firstName": "Zhann",
        "lastName": "Jochinke",
        "jobTitle": "Director of Market Intelligence and Research",
        "organization": "Cavendish Maxwell",
        "photoUrl": "https://static.swapcard.com/public/images/502ab6f6b0c0414091d1e772b1b0c4d0.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA1NjYyOQ==",
                "title": "Unveiling Market Trends: Insights into Branded Residences",
                "categories": [
                    "Branded Residences"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences",
                        "translations": [
                            {
                                "value": "Branded Residences"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMjc1NDU=",
        "type": null,
        "firstName": "His Excellency Issam AbdulRahim",
        "lastName": "Kazim",
        "jobTitle": "Chief Executive Officer",
        "organization": "Dubai Corporation for Tourism and Commerce Marketing (DCTCM)",
        "photoUrl": "https://static.swapcard.com/public/images/cc09bac7d02c41b9bda4d21209c2863c.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU2MA==",
                "title": "The Future Growth of Tourism in Dubai: Harnessing Innovation, Sustainability, Accessibility and Leadership",
                "categories": [
                    "Projects & Destinations",
                    "Green Construction & Smart Cities",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "green-construction-and-smart-cities",
                        "translations": [
                            {
                                "value": "Green Construction & Smart Cities"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMjc4NTM=",
        "type": "Moderator",
        "firstName": "Matthew",
        "lastName": "Weihs",
        "jobTitle": "Group Managing Director",
        "organization": "The Bench",
        "photoUrl": "https://static.swapcard.com/public/images/66e6ed774bd94710bc44d09314173771.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgyOTY2Mg==",
                "title": "Newcomers Welcome",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc4NDkyNQ==",
                "title": "Closing Remarks",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc4MzQyNg==",
                "title": "Welcome",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc4MzQ1Mw==",
                "title": "AHIF AWARDS",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTk0MTY4NA==",
                "title": "Unlocking Africa - Hotel Investment Trends & Outlook",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTQyNQ==",
                "title": "Welcome Remarks",
                "categories": [
                    "Focus on Africa"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMjc4NjM=",
        "type": null,
        "firstName": "Khalil",
        "lastName": "Manji",
        "jobTitle": "Partner",
        "organization": "CHIC",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/77267627507140ceaba781a84bda35ab.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzczNg==",
                "title": "Insights into Africa's Dynamic Investment Landscape",
                "categories": [
                    "Focus on Africa",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMjc4ODg=",
        "type": "Moderator",
        "firstName": "Kathryn",
        "lastName": "Moore",
        "jobTitle": "Managing Director",
        "organization": "Spa Connectors",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/2d11f660bf5f4f36b540573b290c1068.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk5Mg==",
                "title": "Tapping into the $4.7 Trillion Wellness Industry",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA3MzYxMQ==",
                "title": "TenX Leadership Talk: Harmony in Health - Integrating Wellness, Medical Innovations, and Hospitality",
                "categories": [
                    "Wellness & Medical Tourism"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU4Nzc2OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "wellness-and-medical-tourism",
                        "translations": [
                            {
                                "value": "Wellness & Medical Tourism"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMjc5Mjc=",
        "type": null,
        "firstName": "Eezan Shahul",
        "lastName": "Hameed",
        "jobTitle": "Chief Commercial Officer",
        "organization": "Maldives Fund Management Corporation",
        "photoUrl": "https://static.swapcard.com/public/images/277c33646dca4feea257ed48adeb7371.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA0OTQxNQ==",
                "title": "Branded Residences: A New Era in Real Estate Investment",
                "categories": [
                    "Branded Residences",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences",
                        "translations": [
                            {
                                "value": "Branded Residences"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE0OTEyOQ==",
                "title": "Building the Future: The Changing Face of Market and Investor Growth in The Maldives",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTU0Ng==",
                "title": "Building the Future: The Changing Face of Market and Investor Growth in The Maldives",
                "categories": [
                    "Projects & Destinations",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMjgwNDE=",
        "type": "Speaker",
        "firstName": "Amanda",
        "lastName": "Schmiege",
        "jobTitle": "Senior Director of Spa and Wellness",
        "organization": "Four Seasons",
        "photoUrl": "https://static.swapcard.com/public/images/d9434718dced4231a1dfcc3eda2ea234.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk2MQ==",
                "title": "The Future of Wellness: Brand Challenges and Opportunities",
                "categories": [
                    "Wellness & Medical Tourism"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU4Nzc2OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "wellness-and-medical-tourism",
                        "translations": [
                            {
                                "value": "Wellness & Medical Tourism"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMjg5MTQ=",
        "type": null,
        "firstName": "Jamie",
        "lastName": "Odgers",
        "jobTitle": "Director, Real Estate Advisory",
        "organization": "Standard Chartered Bank",
        "photoUrl": "https://static.swapcard.com/public/images/128eddcf137a45a9820b210b5f7cf14c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzY0Nw==",
                "title": "Emergence of Real Estate Investment Trusts in the Middle East",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Bank/Lender",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMjkyNTM=",
        "type": null,
        "firstName": "Olivier",
        "lastName": "Granet",
        "jobTitle": "Managing Partner & Co-CEO",
        "organization": "Kasada Capital Management",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/32a23f374acb499983657003a1453830.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAxMQ==",
                "title": "Strategic Financing of Hospitality Assets: Navigating Uncertainty and Rising Interest Rates for Optimal Funding Solutions",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAwMzE3MQ==",
                "title": "Fireside Chat: How to Align Tourism Strategies Across Key African Markets for Sustainable Growth: From an Investor's Perspective",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMjkyNjQ=",
        "type": null,
        "firstName": "David",
        "lastName": "Damiba",
        "jobTitle": "Managing Partner & Co-CEO",
        "organization": "Kasada Capital Management",
        "photoUrl": "https://static.swapcard.com/public/images/12212ae76a56457b8d8e0c0ab44bef7c.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc4MzQzNA==",
                "title": "Investing with Insight: Strategies for Implementing Optimal Capital Structures in High-Interest Rate Environments",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU5OA==",
                "title": "Capital Talks: Global Investment and the Allure of the Hospitality Industry",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMzAyMTA=",
        "type": "Moderator",
        "firstName": "Alyshia",
        "lastName": "Mangalji",
        "jobTitle": "Vice President - Europe & Africa",
        "organization": "Westmont Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/5231b842784648f6b51d01b072082232.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU5OA==",
                "title": "Capital Talks: Global Investment and the Allure of the Hospitality Industry",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMzAyMzU=",
        "type": null,
        "firstName": "Dr. Naim",
        "lastName": "Maadad",
        "jobTitle": "CEO & Founder",
        "organization": "Gates Hospitality",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/0a0e1122465040f4a3bced2640d97c9a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTM2NTM=",
                "title": "The international perspective",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAzMA==",
                "title": "Socially Responsible Talent Development in Hospitality: A Unified Approach to ESG-Driven Acquisition, Retention, Engagement",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMjk4Mg==",
                "title": "The Impact of Third-Party Outlets on Hotel Revenue and Real Estate Value – What are the Keys to Choosing the Right Operator, Concept and Agreement?",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzc0Mg==",
                "title": "Commercially Driven Asset Management in Hospitality: Strategies for Maximizing Returns",
                "categories": [
                    "Investment & Development",
                    "Hotelisation of Traditional Assets"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMzE0MzM=",
        "type": "Speaker",
        "firstName": "Lindsay",
        "lastName": "Madden-Nadeau",
        "jobTitle": "Senior Director - Wellness Strategy",
        "organization": "Red Sea Global",
        "photoUrl": "https://static.swapcard.com/public/images/2806c5dbdfad47938d50c6aad96c7f24.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk2MQ==",
                "title": "The Future of Wellness: Brand Challenges and Opportunities",
                "categories": [
                    "Wellness & Medical Tourism"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU4Nzc2OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "wellness-and-medical-tourism",
                        "translations": [
                            {
                                "value": "Wellness & Medical Tourism"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxMzUyODE=",
        "type": "Speaker",
        "firstName": "Mark",
        "lastName": "Kirby",
        "jobTitle": "Chief Operating Officer - Head of Hospitality",
        "organization": "Emaar Hospitality Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/92712602ac7047da9f4ff961583cb932.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAyNA==",
                "title": "Branded Residential is Booming: Upfront Planning for Making Your Project a Success",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA3MzU5MQ==",
                "title": "The Rise of Luxury Hospitality: Trends and Differentiators Shaping the Future of High-End Tourism",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxNDYzMTY=",
        "type": null,
        "firstName": "Chiara",
        "lastName": "Caruso",
        "jobTitle": "Director National Tourism Fund",
        "organization": "CDP Real Asset SGR SpA",
        "photoUrl": "https://static.swapcard.com/public/images/8cef1228e35d4f8fb3a2e58d7c6ffbc8.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA0OTU1Mg==",
                "title": "Invest in Italy:  Showcasing Unique Hospitality Projects",
                "categories": [
                    "Investment & Development",
                    "Projects & Destinations",
                    "Focus on Europe"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Real Estate Agent/Surveyor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxNDgwMTI=",
        "type": "Moderator",
        "firstName": "Catherine",
        "lastName": "Edwards",
        "jobTitle": "Chief Strategy Officer",
        "organization": "QUO",
        "photoUrl": "https://static.swapcard.com/public/images/798d8cf33f9346bfa0699b7d1b5f1d6c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTg2OTMyMw==",
                "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – An unbiased Perspective",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzk2MQ==",
                "title": "The Future of Wellness: Brand Challenges and Opportunities",
                "categories": [
                    "Wellness & Medical Tourism"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU4Nzc2OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "wellness-and-medical-tourism",
                        "translations": [
                            {
                                "value": "Wellness & Medical Tourism"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxNDgwNzc=",
        "type": null,
        "firstName": "Naureen",
        "lastName": "Ahmed",
        "jobTitle": "Founder",
        "organization": "Inspiring Women in Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/80178a5951204f6190802570f888975e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyOTkzOA==",
                "title": "Empowering Connections: Networking Session",
                "categories": [
                    "ESG & Human Capital",
                    "Workshop",
                    "Women Leadership"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "workshop",
                        "translations": [
                            {
                                "value": "Workshop"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3MzE2NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "women-leadership",
                        "translations": [
                            {
                                "value": "Women Leadership"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxNTIyNjQ=",
        "type": null,
        "firstName": "Moustafa",
        "lastName": "Said",
        "jobTitle": "Founding Partner",
        "organization": "Wisefields",
        "photoUrl": "https://static.swapcard.com/public/images/18bdf4b7d36e46a4909308223311f493.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgzMDQzMA==",
                "title": "Navigating Regulatory Shifts: Legal Dynamics Reshaping Hospitality Real Estate in the Region and their Impact on Tourism Offerings",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgyNA==",
                "title": "Legal Structures: Protecting Interests of Investors, Purchasers & Brands",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Lawyer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxNTI0MzM=",
        "type": null,
        "firstName": "Duncan",
        "lastName": "O’Rourke",
        "jobTitle": "Chief Executive Officer, Middle East, Africa & Asia Pacific - Premium, Midscale & Economy",
        "organization": "Accor",
        "photoUrl": "https://static.swapcard.com/public/images/1c3e3941e7364f5499e61c5ed5068869.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzY0OQ==",
                "title": "Leading with Purpose: Commitment to People, Planet and Profit",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxNTI4Mzg=",
        "type": null,
        "firstName": "Shamsh",
        "lastName": "Hadi",
        "jobTitle": "Founder & CEO",
        "organization": "ZorroSign",
        "photoUrl": "https://static.swapcard.com/public/images/6540f5750dfe498d9c52e6d65cdf58ab.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA0OTQxOA==",
                "title": "Cyber Resilience in Hospitality: Future-proofing your Data",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxNTQyODc=",
        "type": null,
        "firstName": "Lourie",
        "lastName": "Kruger",
        "jobTitle": "Chief Financial Officer",
        "organization": "Katara Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/3ad8ca3437f048f98b7d1778ec2dff0c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU5OA==",
                "title": "Capital Talks: Global Investment and the Allure of the Hospitality Industry",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxNTU2ODI=",
        "type": null,
        "firstName": "Richard",
        "lastName": "Bursby",
        "jobTitle": "Partner",
        "organization": "Taylor Wessing LLP",
        "photoUrl": "https://static.swapcard.com/public/images/be8666ef6d5f4b7f9e05a941090c5aae.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgyNA==",
                "title": "Legal Structures: Protecting Interests of Investors, Purchasers & Brands",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Lawyer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxNjAyNzA=",
        "type": null,
        "firstName": "Sudhin",
        "lastName": "Siva",
        "jobTitle": "Chief Asset Management Officer",
        "organization": "Shamal Holding",
        "photoUrl": "https://static.swapcard.com/public/images/e6af2a91ddad4cf9bdec80cb33cf8a3a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxOQ==",
                "title": "Marketing Case Studies - Short Presentations by Leading Marketing Professionals Who Have Helped Drive the Success of Branded Residence Projects",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNg==",
                "title": "Unpacking the Benefits of Branded Residences for Investors",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxNjUyOTY=",
        "type": null,
        "firstName": "Richard",
        "lastName": "Stevens",
        "jobTitle": "Group Chief Executive Officer",
        "organization": "Sectorlight",
        "photoUrl": "https://static.swapcard.com/public/images/b9975db8f5b840c89803ea7a02ec590c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxOQ==",
                "title": "Marketing Case Studies - Short Presentations by Leading Marketing Professionals Who Have Helped Drive the Success of Branded Residence Projects",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxNjYyNTM=",
        "type": null,
        "firstName": "Charlie",
        "lastName": "Walsh",
        "jobTitle": "Head of Sales & Marketing",
        "organization": "The OWO Residences by Raffles",
        "photoUrl": "https://static.swapcard.com/public/images/a2589b4788664df7bf2c6cf5adcc0de8.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNg==",
                "title": "Unpacking the Benefits of Branded Residences for Investors",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxNzIxOTk=",
        "type": null,
        "firstName": "Mitra",
        "lastName": "Ghamsari",
        "jobTitle": "Chief Executive Officer",
        "organization": "Persepolis Investments",
        "photoUrl": "https://static.swapcard.com/public/images/1283699d1ef040a1a1ed098536a7b2eb.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1Nw==",
                "title": "Making Standalones Work - Bringing the Brand to Life in the Absence of a Co-Located Hotel",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxNzIyNjc=",
        "type": "Speaker",
        "firstName": "Emlyn",
        "lastName": "Brown",
        "jobTitle": "Senior Vice President - Well-Being",
        "organization": "Accor",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/8d523bcf11cf4589bfebfdfc3c2f5251.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk5Mg==",
                "title": "Tapping into the $4.7 Trillion Wellness Industry",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzk1Ng==",
                "title": "Strategies to Drive the Development and Operation of Sustainable Homeowner Communities that Deliver on Health and Wellbeing Objectives",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxNzM1OTg=",
        "type": "Speaker",
        "firstName": "Gergely",
        "lastName": "Balint, MRICS RV",
        "jobTitle": "Associate Partner, Specialist Valuation",
        "organization": "Cavendish Maxwell",
        "photoUrl": "https://static.swapcard.com/public/images/e277b930f4a6417586f41613c5a530dd.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA0OTU0Nw==",
                "title": "Greening Hospitality: When ESG Law Compliance Impacts Your Hotel Real Estate Value",
                "categories": [
                    "Green Construction & Smart Cities",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "green-construction-and-smart-cities",
                        "translations": [
                            {
                                "value": "Green Construction & Smart Cities"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIxOTkxNjg=",
        "type": null,
        "firstName": "Tjalling van den",
        "lastName": "Burger",
        "jobTitle": "Vice President Enterprise Sales",
        "organization": "Adyen",
        "photoUrl": "https://static.swapcard.com/public/images/462e480c06d3416682a24758e9143c71.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzA1NQ==",
                "title": "Assessing the Role of Technology in Long-Term Value Creation and Its Impact on Investment Decisions",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgwNw==",
                "title": "Back to Basics: Addressing Key Bottlenecks in Hospitality Innovation Before Advancing to Advanced Technologies",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyMTUzODM=",
        "type": null,
        "firstName": "George",
        "lastName": "Azar",
        "jobTitle": "Chairman & CEO",
        "organization": "Sotheby's International Realty",
        "photoUrl": "https://static.swapcard.com/public/images/cf7f682b06ab4e8cb7855d6121a0a3ae.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNg==",
                "title": "Unpacking the Benefits of Branded Residences for Investors",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyMTU0NTI=",
        "type": null,
        "firstName": "Felicity",
        "lastName": "Black-Roberts",
        "jobTitle": "Senior Vice President Development EAME",
        "organization": "Hyatt",
        "photoUrl": "https://static.swapcard.com/public/images/9b72ec6954e8456b9715373dfbac854c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg1Ng==",
                "title": "Resilience Strategies: Building Anti-Fragile Hospitality Investments in Resort Destinations",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Europe"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyMTU1NzQ=",
        "type": null,
        "firstName": "Edward",
        "lastName": "Hamod",
        "jobTitle": "Founder & CEO",
        "organization": "Switch Foods",
        "photoUrl": "https://static.swapcard.com/public/images/2ddf4bfae3c24f37a38fa316887a1758.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA2OTM1OA==",
                "title": "Bridging the Gap: Integrating SDGs into Core Business Strategies for Sustainable Success",
                "categories": [
                    "Restaurant Investment",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyMTYwODk=",
        "type": null,
        "firstName": "Miguel",
        "lastName": "Chillerón",
        "jobTitle": "Director of AI & Design",
        "organization": "Livit Consulting & Design",
        "photoUrl": "https://static.swapcard.com/public/images/b86b7662334f4231a3445b50d1e9426c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4NA==",
                "title": "Unlocking F&B Success: Boosting Hotel Real Estate Value with Effective Third-Party Outlet Agreements",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyMjAwNzI=",
        "type": null,
        "firstName": "Alexis Marcoux",
        "lastName": "Varvatsoulis",
        "jobTitle": "Chief Consulting Officer & Partner",
        "organization": "Livit Consulting & Design",
        "photoUrl": "https://static.swapcard.com/public/images/caa68d0527b648148b9cb3c1ead352a7.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA3OTY2Nw==",
                "title": "Future-Proofing Hospitality: The Evolution of People and Spaces",
                "categories": [
                    "Projects & Destinations",
                    "Green Construction & Smart Cities",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "green-construction-and-smart-cities",
                        "translations": [
                            {
                                "value": "Green Construction & Smart Cities"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyMjEzMjI=",
        "type": null,
        "firstName": "Ricardo",
        "lastName": "Moreira",
        "jobTitle": "Managing Director",
        "organization": "XCO2",
        "photoUrl": "https://static.swapcard.com/public/images/6e8b77a231714caa8c090a646b664940.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1Ng==",
                "title": "Strategies to Drive the Development and Operation of Sustainable Homeowner Communities that Deliver on Health and Wellbeing Objectives",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyMjE5MTY=",
        "type": null,
        "firstName": "Ali",
        "lastName": "Ghaleb Jaber",
        "jobTitle": "Chief Executive Officer",
        "organization": "GJ Properties Investments LLC",
        "photoUrl": "https://static.swapcard.com/public/images/826c4c2e952441b49e7c2545558de69a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA0OTQxNQ==",
                "title": "Branded Residences: A New Era in Real Estate Investment",
                "categories": [
                    "Branded Residences",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences",
                        "translations": [
                            {
                                "value": "Branded Residences"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyNDQ0OTA=",
        "type": null,
        "firstName": "Sarah",
        "lastName": "Duignan",
        "jobTitle": "Director, Client Relationships",
        "organization": "STR",
        "photoUrl": "https://static.swapcard.com/public/images/d6e9b1be93184e2e860029c865367c33.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU4Mw==",
                "title": "What Are the Numbers Telling Us? A Look at Hotel Performance From a Global Perspective",
                "categories": [
                    "Projects & Destinations",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyNTQ3OTI=",
        "type": "Moderator",
        "firstName": "Marco",
        "lastName": "Rentsch",
        "jobTitle": "Partner, Global Consulting Hospitality & Tourism Center of Excellence",
        "organization": "PwC",
        "photoUrl": "https://static.swapcard.com/public/images/027b0439248a48c9bdb22259f039b73a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAwMg==",
                "title": "Converging Digital Transformation in Hospitality: Cross-Industry Best Practices and Implementation Strategies",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzc0MQ==",
                "title": "The Future of Hospitality Management: From White Label Operators, Franchising, to Traditional Management Agreements",
                "categories": [
                    "Hotelisation of Traditional Assets",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyNzY0NTg=",
        "type": "Moderator",
        "firstName": "Jennifer",
        "lastName": "Pettinger",
        "jobTitle": "Co-Founder, Global Restaurant Investment Forum, Partner,",
        "organization": "THINK Hospitality",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/f309f54478254e93bbb14b9f13313b8a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc4MjkxMQ==",
                "title": "Global Restaurant Investment Forum - Welcome",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5NDIzNQ==",
                "title": "Case Study: Continuing the Conversation - Real Facts, Figures and Take Aways that Prove Sustainability can be a Commercial Success",
                "categories": [
                    "Restaurant Investment",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5NDQ4OA==",
                "title": "Bringing Riyadh’s culinary heritage back to life",
                "categories": [
                    "Restaurant Investment",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4NA==",
                "title": "Unlocking F&B Success: Boosting Hotel Real Estate Value with Effective Third-Party Outlet Agreements",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyNzY0NjI=",
        "type": null,
        "firstName": "Atul",
        "lastName": "Chopra",
        "jobTitle": "Founder & CEO",
        "organization": "FreshOnTable",
        "photoUrl": "https://static.swapcard.com/public/images/ef0e284064384703ba06a3f9028e05d6.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA2OTM1OA==",
                "title": "Bridging the Gap: Integrating SDGs into Core Business Strategies for Sustainable Success",
                "categories": [
                    "Restaurant Investment",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyNzcwNzU=",
        "type": "Speaker",
        "firstName": "Jens",
        "lastName": "Schramm",
        "jobTitle": "CEO & Member of the Executive Board",
        "organization": "Robosculptor",
        "photoUrl": "https://static.swapcard.com/public/images/a1e009c4a89745cc83695f789b2a2708.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxMQ==",
                "title": "Disrupting the Market: How AI in the Hospitality Industry Is Changing the Game?",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyODk0MjY=",
        "type": null,
        "firstName": "Ashley",
        "lastName": "Scott",
        "jobTitle": "Global Practice Principal, Planning + Landscape",
        "organization": "WATG",
        "photoUrl": "https://static.swapcard.com/public/images/3f4fe06196d24fd18ff32bbcf1c7f193.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1Ng==",
                "title": "Strategies to Drive the Development and Operation of Sustainable Homeowner Communities that Deliver on Health and Wellbeing Objectives",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyODk0NzE=",
        "type": null,
        "firstName": "Eddy",
        "lastName": "Tannous",
        "jobTitle": "Chief Operating Officer",
        "organization": "Rotana",
        "photoUrl": "https://static.swapcard.com/public/images/0ea10113e8f64d0795d891c9d1769812.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTU3NjUxNw==",
                "title": "EAHM Leadership Series - Creating Harmony: Aligning People, Planet, and Future Growth in Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzcyMA==",
                "title": "Company Culture and Relationships as a Competitive Advantage",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyOTE2MTA=",
        "type": null,
        "firstName": "Husni Al",
        "lastName": "Bayari",
        "jobTitle": "Chairman & Founder",
        "organization": "Bayari Investments",
        "photoUrl": "https://static.swapcard.com/public/images/473d1a48df0a4c8dbfc163ac5e82f405.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNg==",
                "title": "Unpacking the Benefits of Branded Residences for Investors",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyOTE5OTA=",
        "type": null,
        "firstName": "Mohannad",
        "lastName": "Mosly",
        "jobTitle": "Vice President",
        "organization": "SEDCO Capital",
        "photoUrl": "https://static.swapcard.com/public/images/1590b41cb66545e59f333831286eddb2.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzc0Mw==",
                "title": "Beyond Borders: Strategic Fund Structuring for Cross-Border Investments to transform the Global Hospitality Landscape",
                "categories": [
                    "Projects & Destinations",
                    "Hotelisation of Traditional Assets",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyOTIwNjU=",
        "type": "Moderator",
        "firstName": "Peter",
        "lastName": "Bazeli",
        "jobTitle": "Principal and Managing Director",
        "organization": "Weitzman",
        "photoUrl": "https://static.swapcard.com/public/images/d0bb1f67dd6444ebb02e890ec1dd96d1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1Nw==",
                "title": "Making Standalones Work - Bringing the Brand to Life in the Absence of a Co-Located Hotel",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyOTI1MTQ=",
        "type": null,
        "firstName": "Ries",
        "lastName": "Anderson",
        "jobTitle": "Young Leader",
        "organization": null,
        "photoUrl": "https://static.swapcard.com/public/images/e7bdb9ec66504e6ca3efb33aa4d4b724.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzcyMw==",
                "title": "Welcome Back",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyOTI1NDM=",
        "type": null,
        "firstName": "Katrina",
        "lastName": "Chin",
        "jobTitle": "Young Leader",
        "organization": null,
        "photoUrl": "https://static.swapcard.com/public/images/ef6893b85ae34c5dacfc56d8788e0eed.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA4ODY0Nw==",
                "title": "Welcome Back",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyOTI1NjQ=",
        "type": null,
        "firstName": "Emma",
        "lastName": "Doherty",
        "jobTitle": "Young Leader",
        "organization": null,
        "photoUrl": "https://static.swapcard.com/public/images/df1773ecca2f4650bd973dc435ddef25.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA4ODI4OA==",
                "title": "Welcome Back",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyOTI2MDk=",
        "type": null,
        "firstName": "Rahul",
        "lastName": "Dahiya",
        "jobTitle": "Young Leader",
        "organization": null,
        "photoUrl": "https://static.swapcard.com/public/images/bb97d875a4e6448291767655d39ff95f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA4ODYyOA==",
                "title": "Welcome Back",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyOTQ3MDg=",
        "type": null,
        "firstName": "Marco",
        "lastName": "Palamara",
        "jobTitle": "Young Leader",
        "organization": null,
        "photoUrl": "https://static.swapcard.com/public/images/ea0bcb74624846ed900173a908c50f4a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA4ODI4Nw==",
                "title": "Welcome Back",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyOTUyNTI=",
        "type": "Speaker",
        "firstName": "Simone",
        "lastName": "Gibertoni",
        "jobTitle": "Chief Executive Officer",
        "organization": "Clinique La Prairie & Co-founder CLP Holistic Health",
        "photoUrl": "https://static.swapcard.com/public/images/ebe6692dfb6f4c8eb8faa4accbdaaac1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA3MzYxMQ==",
                "title": "TenX Leadership Talk: Harmony in Health - Integrating Wellness, Medical Innovations, and Hospitality",
                "categories": [
                    "Wellness & Medical Tourism"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU4Nzc2OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "wellness-and-medical-tourism",
                        "translations": [
                            {
                                "value": "Wellness & Medical Tourism"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyOTUyODQ=",
        "type": "Moderator",
        "firstName": "Parisa",
        "lastName": "Chum",
        "jobTitle": "Head of Sustainability Communications",
        "organization": "Flint Culture",
        "photoUrl": "https://static.swapcard.com/public/images/3b3ec41c938d467586e3e81c7e49d2af.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA2OTM1OA==",
                "title": "Bridging the Gap: Integrating SDGs into Core Business Strategies for Sustainable Success",
                "categories": [
                    "Restaurant Investment",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyOTg4Njk=",
        "type": "Moderator",
        "firstName": "Radhika",
        "lastName": "Arapally",
        "jobTitle": "Founder",
        "organization": "Sustainability Kiosk",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/496a82994ae94dc1bfbce6ba091a03fa.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzA0Mg==",
                "title": "How will you 'Lead The Change'?",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU2NA==",
                "title": "Net Positive Hospitality: Can Hotels Achieve True Net Positive Hospitality or is it Just a Marketing Ploy",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIyOTkwMDk=",
        "type": "Moderator",
        "firstName": "Katerina",
        "lastName": "Argyrou",
        "jobTitle": "Partner, Real Estate, Hospitality and Leisure",
        "organization": "PwC",
        "photoUrl": "https://static.swapcard.com/public/images/954e64763eed4fa2a6a5524a9158d563.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU1MQ==",
                "title": "Emerging Lifestyle Brands: Bridging Luxury and Midscale Markets with Locally Inspired Experiences in New and Established Destinations",
                "categories": [
                    "Projects & Destinations",
                    "Branding Strategies"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3MzE3Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branding-strategies",
                        "translations": [
                            {
                                "value": "Branding Strategies"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIzMDAyMjY=",
        "type": null,
        "firstName": "Eng. Rawaf I.",
        "lastName": "Bourisli",
        "jobTitle": "Vice Chairman",
        "organization": "Action Hotels",
        "photoUrl": "https://static.swapcard.com/public/images/7b49b585cf1c4124bc60515aab6a68d8.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA2ODg2OQ==",
                "title": "Who’s Really in Charge? The Hidden Power of Third Party Management in Hospitality",
                "categories": [
                    "Hotelisation of Traditional Assets",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIzMjAzNzE=",
        "type": null,
        "firstName": "Hassan",
        "lastName": "Ahdab",
        "jobTitle": "Chief Hospitality Operations Officer",
        "organization": "Taiba Investments",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/29735f117d6442c9a838312bceeeee9e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTM3MTg=",
                "title": "Leaders’ perspective – transform tomorrow and building from the ground up",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzMjk5MQ==",
                "title": "Embracing the Era of the Digital Traveler: Transforming Hotel Operations for the Future",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDYwOA==",
                "title": "ENSURING THE LONG-TERM VIABILITY OF RELIGIOUS TOURISM",
                "categories": [
                    "Culture & Heritage"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "heritage-and-tourism",
                        "translations": [
                            {
                                "value": "Culture & Heritage"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzYwNg==",
                "title": "Hospitality in Saudi Arabia: Aligning with Vision 2030 for a Sustainable Future",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Saudi Arabia",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-saudi-arabia",
                        "translations": [
                            {
                                "value": "Focus on Saudi Arabia"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIzMjEyNzA=",
        "type": null,
        "firstName": "Klaus",
        "lastName": "Kohlmayr",
        "jobTitle": "Chief Evangelist & Development Officer",
        "organization": "IDeaS Revenue Solutions",
        "photoUrl": "https://static.swapcard.com/public/images/429bdd98c67442cca42af343d7180d55.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxMQ==",
                "title": "Disrupting the Market: How AI in the Hospitality Industry Is Changing the Game?",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIzMjEzNzA=",
        "type": null,
        "firstName": "Mohammed",
        "lastName": "Altajir",
        "jobTitle": "Board Member",
        "organization": "Tratok Holding",
        "photoUrl": "https://static.swapcard.com/public/images/7960c604c50a4cd18a40258fe87b7303.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgwNw==",
                "title": "Back to Basics: Addressing Key Bottlenecks in Hospitality Innovation Before Advancing to Advanced Technologies",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Bank/Lender",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIzMzUyMTA=",
        "type": null,
        "firstName": "Francine",
        "lastName": "Aclan",
        "jobTitle": "Young Leader",
        "organization": null,
        "photoUrl": "https://static.swapcard.com/public/images/fa75f1e3e1864c9793d0eb2142ebe26a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA4ODUyNw==",
                "title": "Welcome Back",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIzMzg2NzM=",
        "type": null,
        "firstName": "Paul",
        "lastName": "Keen",
        "jobTitle": "Director of Project Management",
        "organization": "QUO",
        "photoUrl": "https://static.swapcard.com/public/images/4bd6dbb118df460395817d2ffb74d8ff.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzcyMA==",
                "title": "Company Culture and Relationships as a Competitive Advantage",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIzNjU5MTE=",
        "type": "Moderator",
        "firstName": "Zoe",
        "lastName": "Stanford",
        "jobTitle": "Business Development Manager",
        "organization": "Compass Project Consulting",
        "photoUrl": "https://static.swapcard.com/public/images/126e6e90460e429898d7728c53a64da4.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU1OA==",
                "title": "Master Planning for Transformative Hospitality and Destination Investments in Shifting Sands",
                "categories": [
                    "Projects & Destinations"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIzNzQ2OTQ=",
        "type": "Judge",
        "firstName": "Coley",
        "lastName": "Brenan",
        "jobTitle": "Partner & Head of Europe",
        "organization": "KSL Capital Partners",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/912f9161493048bfb746abf77baac9cd.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTA3NzQ5",
                "title": "M&A opportunities: more can kicking or will the vultures swoop?",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTg0MjgwMg==",
                "title": "Diversifying the Economy: Strategies for Attracting Foreign Direct Investment and Achieving Vision 2030 Objectives through Innovative Funding Mechanisms",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzYxMg==",
                "title": "Global Insights: Aligning Growth Strategies for Asset Owner Success",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Nw==",
                "title": "The BIG Project Pitch: International Hospitality Projects Revealed",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Judge",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIzNzg3OTM=",
        "type": null,
        "firstName": "Amir",
        "lastName": "Golbarg",
        "jobTitle": "Senior Vice President - Middle East, Africa & India",
        "organization": "Minor Hotels",
        "photoUrl": "https://static.swapcard.com/public/images/64fe1d3671004a90af6c98e5cf255640.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA3MzU5MQ==",
                "title": "The Rise of Luxury Hospitality: Trends and Differentiators Shaping the Future of High-End Tourism",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIzOTY5Nzc=",
        "type": null,
        "firstName": "Elie",
        "lastName": "Milky",
        "jobTitle": "Vice President Development",
        "organization": "Radisson Hotel Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/3e57faf6b16b416ba6dece262ac74733.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk4Ng==",
                "title": "Building Sustainable Hospitality: Setting the Scene for Hotel Development in the Middle East",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgzMDQzMA==",
                "title": "Navigating Regulatory Shifts: Legal Dynamics Reshaping Hospitality Real Estate in the Region and their Impact on Tourism Offerings",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU1MQ==",
                "title": "Emerging Lifestyle Brands: Bridging Luxury and Midscale Markets with Locally Inspired Experiences in New and Established Destinations",
                "categories": [
                    "Projects & Destinations",
                    "Branding Strategies"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3MzE3Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branding-strategies",
                        "translations": [
                            {
                                "value": "Branding Strategies"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIzOTg0Mzg=",
        "type": null,
        "firstName": "Dr. Fahad",
        "lastName": "bin Mushayt",
        "jobTitle": "Chief Executive Officer",
        "organization": "ASFAR",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/f777a708539f421bb26d3e7dfcc7daad.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk5Nw==",
                "title": "Hospitality Development in Saudi Arabia: Transforming our World - Vision 2030",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
                "title": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU3OQ==",
                "title": "Investing in Saudi Arabia: A Blueprint for Successful Market Entry and Investment",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU1OA==",
                "title": "Master Planning for Transformative Hospitality and Destination Investments in Shifting Sands",
                "categories": [
                    "Projects & Destinations"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzIzOTkyOTI=",
        "type": "Moderator",
        "firstName": "Paula",
        "lastName": "Naoufal",
        "jobTitle": "Senior Reporter",
        "organization": "CNN Business Arabic",
        "photoUrl": "https://static.swapcard.com/public/images/2ad63627a3fa49c3ab5897a30da76d54.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzY0Nw==",
                "title": "Emergence of Real Estate Investment Trusts in the Middle East",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzc0Mw==",
                "title": "Beyond Borders: Strategic Fund Structuring for Cross-Border Investments to transform the Global Hospitality Landscape",
                "categories": [
                    "Projects & Destinations",
                    "Hotelisation of Traditional Assets",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Media",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI0MDI1MjM=",
        "type": null,
        "firstName": "Mark",
        "lastName": "Eacott",
        "jobTitle": "Global VP Design",
        "organization": "Ennismore",
        "photoUrl": "https://static.swapcard.com/public/images/054c0fb6144a4ce5b7674e82c4f827b1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1NQ==",
                "title": "The Leading Edge of Global Residential Markets - Examining The Role of Innovation, Architecture and Design in Branded Residence Projects",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI0MTkzMzA=",
        "type": null,
        "firstName": "Hamza",
        "lastName": "Farooqui",
        "jobTitle": "Chief Executive Officer",
        "organization": "Millat Investment",
        "photoUrl": "https://static.swapcard.com/public/images/4647f1b3e985405383b25e68d832ede9.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgyOTY4MA==",
                "title": "Assessing the Significance and Economic Viability of International Brands in African Destinations",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzczNg==",
                "title": "Insights into Africa's Dynamic Investment Landscape",
                "categories": [
                    "Focus on Africa",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI0MjI5MDQ=",
        "type": "Speaker",
        "firstName": "Imran A",
        "lastName": "Changezi",
        "jobTitle": "Executive Director Hospitality Development",
        "organization": "Diriyah Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/965736d924cf4f0983b4237033eacf72.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAxNg==",
                "title": "Preserving Legacy: Embracing Heritage in Hospitality Design",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgyMg==",
                "title": "Future Telling – What Shapes and Forms will Branded Residences Take in Coming Years",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI0MjM0ODA=",
        "type": null,
        "firstName": "Amit",
        "lastName": "Arora",
        "jobTitle": "Chief Operating Officer",
        "organization": "Arada",
        "photoUrl": "https://static.swapcard.com/public/images/cb22de0ff76c48e080aa1ad8b770b936.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzcyNw==",
                "title": "Capitalizing on the Alternative Accommodation Boom: Unveiling Realities and Global Trends",
                "categories": [
                    "Projects & Destinations",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI0MzY5MTA=",
        "type": null,
        "firstName": "Rosa",
        "lastName": "Piro",
        "jobTitle": "Senior Business Development Director",
        "organization": "Arada",
        "photoUrl": "https://static.swapcard.com/public/images/08f9fc81218941db8921678dc03d98ca.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1Nw==",
                "title": "Making Standalones Work - Bringing the Brand to Life in the Absence of a Co-Located Hotel",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI0NDM1Mjg=",
        "type": null,
        "firstName": "Thomas",
        "lastName": "B. Meier",
        "jobTitle": "Chief Operating Officer and interim Chief Executive Officer",
        "organization": "Jumeirah",
        "photoUrl": "https://static.swapcard.com/public/images/4740f0521fa54a2d8ad70defcfec57a1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzc0Mw==",
                "title": "Beyond Borders: Strategic Fund Structuring for Cross-Border Investments to transform the Global Hospitality Landscape",
                "categories": [
                    "Projects & Destinations",
                    "Hotelisation of Traditional Assets",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI0NDM4ODk=",
        "type": null,
        "firstName": "Bryanne",
        "lastName": "Tait",
        "jobTitle": "Group Senior Director Sustainability",
        "organization": "Jumeirah",
        "photoUrl": "https://static.swapcard.com/public/images/e353cc9489a846b191e25d8e1253c738.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA2OTM1OA==",
                "title": "Bridging the Gap: Integrating SDGs into Core Business Strategies for Sustainable Success",
                "categories": [
                    "Restaurant Investment",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI0NDkzMTM=",
        "type": null,
        "firstName": "Engy",
        "lastName": "Naguib",
        "jobTitle": "Senior Engagement Manager - Tourism",
        "organization": "Euromonitor International",
        "photoUrl": "https://static.swapcard.com/public/images/f34b7d497d9f46ba9c4ea5969a858757.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjExODMzMw==",
                "title": "Journey to a Sustainable Tourism Future: Paving the Way for Eco-Friendly Travel",
                "categories": [
                    "Intelligence Talks",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0ODk4Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "intelligence-talks",
                        "translations": [
                            {
                                "value": "Intelligence Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI0NDkzNDQ=",
        "type": "Speaker",
        "firstName": "Imad",
        "lastName": "Barrakad",
        "jobTitle": "Chairman & CEO",
        "organization": "The Moroccan Agency for Tourism Development (SMIT)",
        "photoUrl": "https://static.swapcard.com/public/images/65cd13c87a23471083e971e7c622b9f2.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU1OA==",
                "title": "Master Planning for Transformative Hospitality and Destination Investments in Shifting Sands",
                "categories": [
                    "Projects & Destinations"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI0NzYzODY=",
        "type": "Moderator",
        "firstName": "Judith",
        "lastName": "Cartwright",
        "jobTitle": "Founder & Managing Director",
        "organization": "Black Coral Consulting",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/efa02cf95da1468d9d912a2d6314cb69.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTg1MTM5Nw==",
                "title": "TenX Leadership Talks: Emergence of Third-Party Operators in Saudi Arabia's Dynamic Market and The Prospects for Growth in Saudi Arabia?",
                "categories": [
                    "Investment & Development",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzc0Mg==",
                "title": "Commercially Driven Asset Management in Hospitality: Strategies for Maximizing Returns",
                "categories": [
                    "Investment & Development",
                    "Hotelisation of Traditional Assets"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI0ODcxOTU=",
        "type": "Moderator",
        "firstName": "Nicolas",
        "lastName": "Mayer",
        "jobTitle": "Global Tourism and Hospitality Industry Leader",
        "organization": "PwC",
        "photoUrl": "https://static.swapcard.com/public/images/9dabe03ef1ae4c8eb532ba3788623229.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA2ODg2OQ==",
                "title": "Who’s Really in Charge? The Hidden Power of Third Party Management in Hospitality",
                "categories": [
                    "Hotelisation of Traditional Assets",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI1MDcxNTA=",
        "type": null,
        "firstName": "Amith",
        "lastName": "Khanna",
        "jobTitle": "Head of Franchise, IMEA",
        "organization": "IHG Hotels & Resorts",
        "photoUrl": "https://static.swapcard.com/public/images/86c17c7f261c44cb8239d4f273866fa5.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk5OA==",
                "title": "The Rise of Third-Party Operators in Hotel Management: What are the Advantages over Traditional Models and How to Find the Right Solution for Investors",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgyOTY4MA==",
                "title": "Assessing the Significance and Economic Viability of International Brands in African Destinations",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzc0MQ==",
                "title": "The Future of Hospitality Management: From White Label Operators, Franchising, to Traditional Management Agreements",
                "categories": [
                    "Hotelisation of Traditional Assets",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI1NDkzMTA=",
        "type": "Moderator",
        "firstName": "Andy",
        "lastName": "Hawkins",
        "jobTitle": "Head of Global Residential Development Sales",
        "organization": "Savills",
        "photoUrl": "https://static.swapcard.com/public/images/bd01a52490254818a0aeb8a2ffc5954a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1NQ==",
                "title": "The Leading Edge of Global Residential Markets - Examining The Role of Innovation, Architecture and Design in Branded Residence Projects",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Real Estate Agent/Surveyor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI1NTQ1Mzc=",
        "type": "Moderator",
        "firstName": "Alain",
        "lastName": "Debare",
        "jobTitle": "Partner – Head of Investments and Asset Management, Middle East and Africa",
        "organization": "HVS",
        "photoUrl": "https://static.swapcard.com/public/images/11af651213334255bb3dcca860e5614a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzczNg==",
                "title": "Insights into Africa's Dynamic Investment Landscape",
                "categories": [
                    "Focus on Africa",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI1NTczNjM=",
        "type": "Moderator",
        "firstName": "Lenah",
        "lastName": "Hassaballah",
        "jobTitle": "Editor",
        "organization": "CNN Business Arabic",
        "photoUrl": "https://static.swapcard.com/public/images/1ca82aa592884f7fbf0fec8e2d09949b.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzcxNw==",
                "title": "Trailblazing Careers in Hospitality: Leading the Way",
                "categories": [
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU4Nw==",
                "title": "Balancing Growth: Integrating Tourism in Government Policy-Making to Tackle Overtourism and Other Key Challenges",
                "categories": [
                    "Projects & Destinations",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjEwNzQ0NA==",
                "title": "A Global Perspective: UN Tourism's Role in Addressing Sustainable Growth in Travel",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Media",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI1NTc0NzA=",
        "type": null,
        "firstName": "Laurent",
        "lastName": "Cartier",
        "jobTitle": "Chief Research & Development Officer",
        "organization": "Amsa Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/a5a437ad4c61416a997150cbc982ef44.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxMg==",
                "title": "Digital Transformation - The Future of Design and Customer Experience",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI1NjkwMDQ=",
        "type": null,
        "firstName": "Gavin",
        "lastName": "Weaver",
        "jobTitle": "Regional Director",
        "organization": "AtkinsRéalis",
        "photoUrl": "https://static.swapcard.com/public/images/7c95a4ed367e40a4b33fe03dc3cc35bc.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgwNw==",
                "title": "Back to Basics: Addressing Key Bottlenecks in Hospitality Innovation Before Advancing to Advanced Technologies",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI1ODg0OTA=",
        "type": null,
        "firstName": "Elyza",
        "lastName": "Falzon",
        "jobTitle": "Vice President - Architecture, Design & Construction ME & SSA",
        "organization": "Hilton",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/9a5c3f84af374083ba66f43de4cddaac.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAzMQ==",
                "title": "Shaping the Next Decade: The Evolution of Hotel Architecture in the Era of Technology, Sustainability, and Changing Traveler Preferences",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU5OQ==",
                "title": "Building Tomorrow: The Impact of Sustainable Construction on Evolving Demand Trends",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA1MTE5OQ==",
                "title": "New Horizons Ahead: Trends and Developments in Tomorrow’s Designs",
                "categories": [
                    "Projects & Destinations",
                    "Green Construction & Smart Cities",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "green-construction-and-smart-cities",
                        "translations": [
                            {
                                "value": "Green Construction & Smart Cities"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI2MjEwMzE=",
        "type": "Moderator",
        "firstName": "Seymone",
        "lastName": "Moodley",
        "jobTitle": "Editor In Chief",
        "organization": "Hotel & Catering News Middle East",
        "photoUrl": "https://static.swapcard.com/public/images/6ce9b17453ef46528b9a82c8404c0524.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4MQ==",
                "title": "Beyond the Plate: Culinary Experiences as a Pillar of Destination Tourism",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI2MzAzNjE=",
        "type": "Moderator",
        "firstName": "Nicholas",
        "lastName": "Nahas",
        "jobTitle": "Partner",
        "organization": "Arthur D. Little",
        "photoUrl": "https://static.swapcard.com/public/images/0e7bf6a861424a608302179b6d96dea6.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA3MzU5MQ==",
                "title": "The Rise of Luxury Hospitality: Trends and Differentiators Shaping the Future of High-End Tourism",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI2ODIzNzY=",
        "type": "Moderator",
        "firstName": "David",
        "lastName": "Singleton",
        "jobTitle": "Founder",
        "organization": "Oraculi",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/a4234bad263246c3ba7ed24c70df0aa2.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzA0Mg==",
                "title": "How will you 'Lead The Change'?",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Nw==",
                "title": "The BIG Project Pitch: International Hospitality Projects Revealed",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI2OTIwMjY=",
        "type": "Speaker",
        "firstName": "Tariq",
        "lastName": "Valani",
        "jobTitle": "Senior Vice President - Global Support Services",
        "organization": "Accor",
        "photoUrl": "https://static.swapcard.com/public/images/836b0380358548d783d78e501cd084c3.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA4ODY3OQ==",
                "title": "From Search to Stay: Enhancing Booking Tech for a Seamless Guest Journey",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI2OTMwNDI=",
        "type": "Speaker",
        "firstName": "Samy",
        "lastName": "Boukhaled",
        "jobTitle": "Vice President",
        "organization": "Elaf Hotels",
        "photoUrl": "https://static.swapcard.com/public/images/f1dfb83ca8cf4ec29d4e9a86ef49a8bf.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzYwNg==",
                "title": "Hospitality in Saudi Arabia: Aligning with Vision 2030 for a Sustainable Future",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Saudi Arabia",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-saudi-arabia",
                        "translations": [
                            {
                                "value": "Focus on Saudi Arabia"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI2OTMxNzE=",
        "type": "Speaker",
        "firstName": "Adeeb",
        "lastName": "Ahamed",
        "jobTitle": "Managing Director",
        "organization": "Twenty14 Holdings",
        "photoUrl": "https://static.swapcard.com/public/images/f704fc6dead54ffcb162e11434543fc8.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU5OA==",
                "title": "Capital Talks: Global Investment and the Allure of the Hospitality Industry",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI2OTMyNTQ=",
        "type": "Speaker",
        "firstName": "Anil",
        "lastName": "Bhardwaj",
        "jobTitle": "Director",
        "organization": "The Arenco Group",
        "photoUrl": "https://static.swapcard.com/public/images/bc38b0de8a1741849b422b1cf80d5f48.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4NA==",
                "title": "Unlocking F&B Success: Boosting Hotel Real Estate Value with Effective Third-Party Outlet Agreements",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI2OTM1MjI=",
        "type": "Speaker",
        "firstName": "Khaled A.",
        "lastName": "Kaawar",
        "jobTitle": "Chief Executive Officer",
        "organization": "Strata Global Holdings",
        "photoUrl": "https://static.swapcard.com/public/images/2eda337d8e8b4cbbb2ffada160125b4d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgyNA==",
                "title": "Legal Structures: Protecting Interests of Investors, Purchasers & Brands",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI2OTM3MjY=",
        "type": "Speaker",
        "firstName": "Amir",
        "lastName": "Lababedi",
        "jobTitle": "Managing Director Development MENA",
        "organization": "Hilton",
        "photoUrl": "https://static.swapcard.com/public/images/c7d9ecf2b59d433fadc4d12a20418066.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTQ2ODE=",
                "title": "The three minute pitch to owners - LOYALTY SCHEMES & DRIVING DISTRIBUTION",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAwMQ==",
                "title": "Creating Thriving Mixed-Use Developments: The Synergy of Culture, Entertainment and Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzYwNg==",
                "title": "Hospitality in Saudi Arabia: Aligning with Vision 2030 for a Sustainable Future",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Saudi Arabia",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-saudi-arabia",
                        "translations": [
                            {
                                "value": "Focus on Saudi Arabia"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI2OTM3ODc=",
        "type": "Moderator",
        "firstName": "Jules",
        "lastName": "Ugo",
        "jobTitle": "Chief Executive Officer",
        "organization": "LOTUS Arabia",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/b6731e369c8e42d18c1e81aec244adb2.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgyMDAxNw==",
                "title": "Creating and Reinventing Destinations: From Conception to Cultivation",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTkxNDk2MQ==",
                "title": "TenX Leadership Talks: Insights and Learnings in the Journey of Growing Your Destination",
                "categories": [
                    "Investment & Development",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg1OA==",
                "title": "Tourism 2.0: Transforming Destination Investment into an Unmatched Opportunity",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTU1Mg==",
                "title": "Invest in Italy:  Showcasing Unique Hospitality Projects",
                "categories": [
                    "Investment & Development",
                    "Projects & Destinations",
                    "Focus on Europe"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjEyMjY5NA==",
                "title": "Building Tomorrow: Pioneering Sustainable Hospitality Development",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI2OTM3OTk=",
        "type": "Speaker",
        "firstName": "Gaurav",
        "lastName": "Sinha",
        "jobTitle": "Chief Executive Officer",
        "organization": "Insignia Worldwide",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/90fc35e1480c41078f9fcdb37669236e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTM2OTk=",
                "title": "How to promote Saudi as a sustainable destination",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAxNg==",
                "title": "Preserving Legacy: Embracing Heritage in Hospitality Design",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5MTg0MQ==",
                "title": "Empowering Hospitality: Leading the Way in Crafting a Diverse, Inclusive Lifestyle Brand and Transforming Human Experience",
                "categories": [
                    "ESG & Human Capital",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE0NDE1NQ==",
                "title": "Next-Gen Lifestyle Brands: Leveraging International Branding to Integrate Local Art, Culture, and Destination Experiences",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI2OTM4Nzg=",
        "type": null,
        "firstName": "Ayman",
        "lastName": "Ezzeddine",
        "jobTitle": "Director Development",
        "organization": "Radisson Hotel Group",
        "photoUrl": null,
        "speakerOnPlannings": [],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI2OTQ5MDI=",
        "type": "Speaker",
        "firstName": "Dr. Peter",
        "lastName": "Ebertz",
        "jobTitle": "Managing Director & Head of Hotels",
        "organization": "Art-Invest Real Estate Management",
        "photoUrl": "https://static.swapcard.com/public/images/6cb293c31e64486bab0e003f69158d31.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA1MTE4OA==",
                "title": "European Hospitality Revival: Creating Investment Opportunities in Mature Markets",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Europe",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI3MTQ5NjI=",
        "type": "Moderator",
        "firstName": "Ben",
        "lastName": "Baseley-Walker",
        "jobTitle": "Founder & Managing Partner",
        "organization": "Andart Global",
        "photoUrl": "https://static.swapcard.com/public/images/d56dd714dff84ff7aaf1c558c1c30e56.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk4MQ==",
                "title": "Expanding Horizons in Tourism Destination Development",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg3MTQ0NQ==",
                "title": "How the changing City Dynamic influences Hospitality Offerings and the Consumer",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5NDI0MA==",
                "title": "Insights from Asia: What lessons can be learnt from other fast growing markets around the world?",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE0OTEyOQ==",
                "title": "Building the Future: The Changing Face of Market and Investor Growth in The Maldives",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTU0Ng==",
                "title": "Building the Future: The Changing Face of Market and Investor Growth in The Maldives",
                "categories": [
                    "Projects & Destinations",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI3MjAzODQ=",
        "type": "Speaker",
        "firstName": "Majd",
        "lastName": "Hamamouchi",
        "jobTitle": "Corporate Business Development Director",
        "organization": "TIME Hotels",
        "photoUrl": "https://static.swapcard.com/public/images/40b37be6c6274e68bf11b6b4bce3393f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjE0OTEyOQ==",
                "title": "Building the Future: The Changing Face of Market and Investor Growth in The Maldives",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI3Mjc1OTE=",
        "type": null,
        "firstName": "Philip S.",
        "lastName": "Gillard",
        "jobTitle": "Managing Director",
        "organization": "Arquitectonica",
        "photoUrl": "https://static.swapcard.com/public/images/c6f0306a44ed40459dd68e4ac2a00115.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1NQ==",
                "title": "The Leading Edge of Global Residential Markets - Examining The Role of Innovation, Architecture and Design in Branded Residence Projects",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI3MzI3MTg=",
        "type": null,
        "firstName": "Sally",
        "lastName": "Maier-Yip",
        "jobTitle": "Founder & Managing Director",
        "organization": "11K Consulting",
        "photoUrl": "https://static.swapcard.com/public/images/e167271ea40e48a09196616faa91965f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxOQ==",
                "title": "Marketing Case Studies - Short Presentations by Leading Marketing Professionals Who Have Helped Drive the Success of Branded Residence Projects",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI3MzcwOTg=",
        "type": "Speaker",
        "firstName": "Aseem",
        "lastName": "Kapoor",
        "jobTitle": "Founder & Chief Executive",
        "organization": "ARK People Solutions",
        "photoUrl": "https://static.swapcard.com/public/images/e21e2fc552dd494db5adfb664df799cd.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA2OTM1NQ==",
                "title": "Global Expertise, Local Talent: Hospitality's Balancing Act",
                "categories": [
                    "Education Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3MjkwMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "education-investment",
                        "translations": [
                            {
                                "value": "Education Investment"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI3NjM2NjY=",
        "type": null,
        "firstName": "Federica",
        "lastName": "Grignolo",
        "jobTitle": "Associate",
        "organization": "Studio Carter",
        "photoUrl": "https://static.swapcard.com/public/images/db9d44432901412dba410405c5020750.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1NQ==",
                "title": "The Leading Edge of Global Residential Markets - Examining The Role of Innovation, Architecture and Design in Branded Residence Projects",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI3Njk1NTg=",
        "type": null,
        "firstName": "Bhagya",
        "lastName": "Mahavithanage",
        "jobTitle": "Deputy Director - Investor Relations Unit",
        "organization": "Sri Lanka Tourism Development Authority",
        "photoUrl": "https://static.swapcard.com/public/images/72218a6445cf4a02bc6578850f6d4083.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg1OA==",
                "title": "Tourism 2.0: Transforming Destination Investment into an Unmatched Opportunity",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI3NzMzMDQ=",
        "type": null,
        "firstName": "Tiffany",
        "lastName": "McGrath",
        "jobTitle": "Director Sustainable Hospitality",
        "organization": "Sustainability Kiosk",
        "photoUrl": "https://static.swapcard.com/public/images/8b834ea0ae974f30955e53478af70fc9.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI3NzM2MjA=",
        "type": "Moderator",
        "firstName": "Georgette",
        "lastName": "Davey",
        "jobTitle": "Managing Director",
        "organization": "Abu Dhabi Hospitality Academy Les Roches",
        "photoUrl": "https://static.swapcard.com/public/images/1cbee61643fe41a0bb825740f1d57e57.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA2OTM1NQ==",
                "title": "Global Expertise, Local Talent: Hospitality's Balancing Act",
                "categories": [
                    "Education Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3MjkwMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "education-investment",
                        "translations": [
                            {
                                "value": "Education Investment"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI4MjI3OTI=",
        "type": null,
        "firstName": "Agnès",
        "lastName": "Roquefort",
        "jobTitle": "Global Chief Development Officer Luxury & Lifestyle",
        "organization": "Accor",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/b11bfb415f7942958d0cd947ffd68b3c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgyMDAxNA==",
                "title": "Travelling for Good: Innovations in Luxury Travel for Responsible Tourism Development",
                "categories": [
                    "ESG & Human Capital"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA3MzU5MQ==",
                "title": "The Rise of Luxury Hospitality: Trends and Differentiators Shaping the Future of High-End Tourism",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI4MjczMjI=",
        "type": null,
        "firstName": "Eng. Sultan",
        "lastName": "Alshehri",
        "jobTitle": "Chief of Investment",
        "organization": "Aseer Development Authority",
        "photoUrl": "https://static.swapcard.com/public/images/a0aa1e8ec7034070983f61d7616eebde.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzYwNg==",
                "title": "Hospitality in Saudi Arabia: Aligning with Vision 2030 for a Sustainable Future",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Saudi Arabia",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-saudi-arabia",
                        "translations": [
                            {
                                "value": "Focus on Saudi Arabia"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI4Mjg0ODQ=",
        "type": "Speaker",
        "firstName": "Younes",
        "lastName": "Hajoui",
        "jobTitle": "Director of Investment Development",
        "organization": "Moroccan Agency for Tourism Development SMIT",
        "photoUrl": "https://static.swapcard.com/public/images/53c45e883355424bbfc9e6557b54be50.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAzMw==",
                "title": "Morocco's New Tourism Roadmap: Unveiling new Investment Projects",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTU0OA==",
                "title": "Invest in Morocco:  Showcasing Unique Hospitality Projects",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Africa",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI4NTc4NjM=",
        "type": "Speaker",
        "firstName": "Wyatt",
        "lastName": "Roy",
        "jobTitle": "Head of Innovation",
        "organization": "NEOM",
        "photoUrl": "https://static.swapcard.com/public/images/d7b71cbba4634710aa4b766eb7d17958.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU1OA==",
                "title": "Master Planning for Transformative Hospitality and Destination Investments in Shifting Sands",
                "categories": [
                    "Projects & Destinations"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI4NjYxMDA=",
        "type": "Speaker",
        "firstName": "Suma",
        "lastName": "Venkatesh",
        "jobTitle": "Executive Vice President - Real Estate & Development",
        "organization": "The Indian Hotels Company Limited",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/ab0f7a5ca0ac4be2a3e2f1d4b1154738.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzA1MQ==",
                "title": "Why India Matters in Hospitality Investment",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc4MjkyMA==",
                "title": "Transforming Palaces: Embracing Heritage and Showcasing New Luxury",
                "categories": [
                    "Culture & Heritage"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "heritage-and-tourism",
                        "translations": [
                            {
                                "value": "Culture & Heritage"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzc0Mg==",
                "title": "Commercially Driven Asset Management in Hospitality: Strategies for Maximizing Returns",
                "categories": [
                    "Investment & Development",
                    "Hotelisation of Traditional Assets"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI5MDA0MDM=",
        "type": "Delegate",
        "firstName": "Ines",
        "lastName": "Abel",
        "jobTitle": "CEO & Founder",
        "organization": "Luxury Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/54f9e6d234fa4a3aa47abd89d4d70914.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Nw==",
                "title": "The BIG Project Pitch: International Hospitality Projects Revealed",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Delegate",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI5MDEwMTI=",
        "type": "Speaker",
        "firstName": "Siegfried",
        "lastName": "Nierhaus",
        "jobTitle": "Vice President/Head of Development Middle East, India, Africa",
        "organization": "H World International",
        "photoUrl": "https://static.swapcard.com/public/images/64ba4b14b8904209bfae35c6518ce156.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzc0Mw==",
                "title": "Beyond Borders: Strategic Fund Structuring for Cross-Border Investments to transform the Global Hospitality Landscape",
                "categories": [
                    "Projects & Destinations",
                    "Hotelisation of Traditional Assets",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI5MDc1OTY=",
        "type": "Speaker",
        "firstName": "Puneet",
        "lastName": "Chhatwal",
        "jobTitle": "Managing Director & CEO",
        "organization": "Indian Hotels Company Limited",
        "photoUrl": "https://static.swapcard.com/public/images/a317878f51c94beeb2687d2b0e88f8b8.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjExNTUzOA==",
                "title": "India 2047: The Future of Travel and Hospitality in India​",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI5MTA5ODU=",
        "type": "Speaker",
        "firstName": "Peter",
        "lastName": "Heneghan",
        "jobTitle": "Futurist and Founder of AI & Communications agency",
        "organization": "The Future Communicator",
        "photoUrl": "https://static.swapcard.com/public/images/536c882dc333446f810758bd092173ef.webp",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxMQ==",
                "title": "Disrupting the Market: How AI in the Hospitality Industry Is Changing the Game?",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgyMg==",
                "title": "Future Telling – What Shapes and Forms will Branded Residences Take in Coming Years",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI5MTkyMTA=",
        "type": "Judge",
        "firstName": "Philipp",
        "lastName": "Klohr",
        "jobTitle": "Senior Vice President",
        "organization": "Mubadala",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/70925a87800142b28e7c1d6c23f6ded0.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAyMQ==",
                "title": "The Business Case for ESG Integration: Exploring the Commercial Benefits and Opportunities for Real Estate Investors and Developers",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Nw==",
                "title": "The BIG Project Pitch: International Hospitality Projects Revealed",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Judge",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI5MjQwMjA=",
        "type": "Speaker",
        "firstName": "Michael",
        "lastName": "Dyke",
        "jobTitle": "Chief Executive Officer",
        "organization": "New Murabba Development Company",
        "photoUrl": "https://static.swapcard.com/public/images/505a6f5795b04e1e992f654406deb3db.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA3MTcyMQ==",
                "title": "Iconic Developments: Navigating the Next Wave of Urban Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI5MjU5NTM=",
        "type": null,
        "firstName": "Jeff",
        "lastName": "Strachan",
        "jobTitle": "AVP Business Operations",
        "organization": "Dubai College of Tourism",
        "photoUrl": "https://static.swapcard.com/public/images/9be4b8c826d04099aadc8458374a3ef2.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA0NDk4OA==",
                "title": "Round Table: Transforming Education for the Future of Hospitality",
                "categories": [
                    "Workshop"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "workshop",
                        "translations": [
                            {
                                "value": "Workshop"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI5MjcyOTA=",
        "type": "Speaker",
        "firstName": "Larissa",
        "lastName": "Esser",
        "jobTitle": "Senior Director International Transactions",
        "organization": "Colliers",
        "photoUrl": "https://static.swapcard.com/public/images/17a8fd55607b40008b6b49ac4cde22e7.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA1MTE4Nw==",
                "title": "Spotlight European Hospitality: 2024, the Turning Point for Transactional Activity",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Europe",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI5MzQ5NTE=",
        "type": "Speaker",
        "firstName": "Vijay",
        "lastName": "Raghavan",
        "jobTitle": "Director",
        "organization": "Arenco",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/01c5c010481942ebbc02e594873303ba.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAxNQ==",
                "title": "Hotel Transactions: Insights for 2023",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzYxMg==",
                "title": "Global Insights: Aligning Growth Strategies for Asset Owner Success",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI5NTAzMDQ=",
        "type": "Speaker",
        "firstName": "William-Harley",
        "lastName": "Fleming",
        "jobTitle": "Chief Operating Officer",
        "organization": "Millennium Hotels & Resorts Middle East & Africa",
        "photoUrl": "https://static.swapcard.com/public/images/8b79f370a3ba406aa9bb58de1634306a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzcyMA==",
                "title": "Company Culture and Relationships as a Competitive Advantage",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI5NTgzMTU=",
        "type": "Moderator",
        "firstName": "Yousef",
        "lastName": "Gamal El-Din",
        "jobTitle": "Anchor and Entrepreneur",
        "organization": "Stagespring",
        "photoUrl": "https://static.swapcard.com/public/images/5b02a1deed2244c784ae60c9ea7b925e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzYwNg==",
                "title": "Hospitality in Saudi Arabia: Aligning with Vision 2030 for a Sustainable Future",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Saudi Arabia",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-saudi-arabia",
                        "translations": [
                            {
                                "value": "Focus on Saudi Arabia"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Media",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI5NjIwMTk=",
        "type": null,
        "firstName": "Barry",
        "lastName": "Robinson",
        "jobTitle": "President and Managing Director International Operations",
        "organization": "Travel and Leisure Co",
        "photoUrl": "https://static.swapcard.com/public/images/390b7dc3654344f89acb74e89d46febd.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjE0NjM4NA==",
                "title": "Shared Ownership in Dubai and Across Region. Is the Promise of Vacation Ownership, Fractional and Private Residence Clubs about to be Realized?",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": []
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzI5ODU3MDI=",
        "type": "Moderator",
        "firstName": "Curtis",
        "lastName": "Tischler",
        "jobTitle": "CEO & Founder",
        "organization": "SagePoint Real Estate Company, INC.",
        "photoUrl": "https://static.swapcard.com/public/images/c197a76203a843a897a4353f3abe442e.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxOQ==",
                "title": "Marketing Case Studies - Short Presentations by Leading Marketing Professionals Who Have Helped Drive the Success of Branded Residence Projects",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Real Estate Agent/Surveyor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMwMTg2MjQ=",
        "type": "Speaker",
        "firstName": "Dennis",
        "lastName": "Ledenkof",
        "jobTitle": "Chief Executive Office",
        "organization": "RoboSculptor",
        "photoUrl": "https://static.swapcard.com/public/images/878687228c8c450884137e199fb1f49d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzkwOQ==",
                "title": "Tech-Driven Tranquility: Enhancing Wellness Through Robotics",
                "categories": [
                    "Competitions"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "competitions",
                        "translations": [
                            {
                                "value": "Competitions"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMwMjc2NTg=",
        "type": "Speaker",
        "firstName": "Selim",
        "lastName": "El Zyr",
        "jobTitle": "Vice Chairman and Co-Founder",
        "organization": "Rotana",
        "photoUrl": "https://static.swapcard.com/public/images/58ac505ed69149eeb238a070969bb41a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAzNTg1Mw==",
                "title": "FHS Awards 2024",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMwMzU1MTg=",
        "type": "Delegate",
        "firstName": "Louis",
        "lastName": "Thompson",
        "jobTitle": "Chief Executive Officer",
        "organization": "Nomadic Resorts",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/8258815cc5304a04a04d76903e376971.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Nw==",
                "title": "The BIG Project Pitch: International Hospitality Projects Revealed",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Delegate",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMwNTYyMzk=",
        "type": "Moderator",
        "firstName": "Mark",
        "lastName": "Dunford",
        "jobTitle": "Chief Executive Officer",
        "organization": "Knight Frank",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/352fde424a6649bebad7f542f7827152.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc4MzQzNw==",
                "title": "Capitalizing Growth: Spotlight on Active Development Financial Institutions",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTkzMzEyMQ==",
                "title": "Hospitality Leaders Unplugged: Ask Us Anything",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzc0MA==",
                "title": "From Nepal to the World: A Journey of Strategic Investment, Development, and Asset Management",
                "categories": [
                    "Focus on Africa"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMwNTY5Mjk=",
        "type": "Speaker",
        "firstName": "Khawla Al",
        "lastName": "Hashimi",
        "jobTitle": "Chief Projects Officer",
        "organization": "Sharjah Investment and Development Authority - Shurooq",
        "photoUrl": "https://static.swapcard.com/public/images/3eab35b42a114829a3dd84d8ea402d5d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU1OA==",
                "title": "Master Planning for Transformative Hospitality and Destination Investments in Shifting Sands",
                "categories": [
                    "Projects & Destinations"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMwNTk4MDE=",
        "type": "Judge",
        "firstName": "Luis Nicolas",
        "lastName": "Barrios",
        "jobTitle": "Regional Manager Innovation Education and Investment",
        "organization": "UN Tourism",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/3e48bf508a3f4f5a855d9b179a19b4ec.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc1MDU5MA==",
                "title": "Shaping the Kingdom's Destiny: Cultivating Excellence in Hospitality to Shaping Policies and Initiatives that Contribute to Making Hospitality a Great Industry to Work in",
                "categories": [
                    "ESG & Human Capital"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NA==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Competitions"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "competitions",
                        "translations": [
                            {
                                "value": "Competitions"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NQ==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Judge",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMwNjEzMTI=",
        "type": "Speaker",
        "firstName": "Fatim-Zahra",
        "lastName": "Ammor",
        "jobTitle": "Minister of Tourism, Crafts and Social and Solidarity Economy",
        "organization": "Kingdom of Morocco",
        "photoUrl": "https://static.swapcard.com/public/images/2930ed33c5bd429aa1bf2fedfbbb707d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU4Nw==",
                "title": "Balancing Growth: Integrating Tourism in Government Policy-Making to Tackle Overtourism and Other Key Challenges",
                "categories": [
                    "Projects & Destinations",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMxMjE0Njk=",
        "type": "Speaker",
        "firstName": "Osama",
        "lastName": "AlOthman",
        "jobTitle": "Chief Executive Officer",
        "organization": "Aseer Investment Company",
        "photoUrl": "https://static.swapcard.com/public/images/b038fa1f384840f6a33e9343296ee305.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjEyMjY5NA==",
                "title": "Building Tomorrow: Pioneering Sustainable Hospitality Development",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMxMjgxMDY=",
        "type": "Speaker",
        "firstName": "Shaikha Al",
        "lastName": "Nowais",
        "jobTitle": "Corporate Vice President - Owner Relationship Management",
        "organization": "Rotana",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/021971f022ac456db0218fde09ed3808.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc1MDYwMA==",
                "title": "Breaking Barriers, Shaping the Future: Women in Tourism & Hospitality Leadership",
                "categories": [
                    "ESG & Human Capital"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA2OTM1NQ==",
                "title": "Global Expertise, Local Talent: Hospitality's Balancing Act",
                "categories": [
                    "Education Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3MjkwMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "education-investment",
                        "translations": [
                            {
                                "value": "Education Investment"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMxMzIzNDY=",
        "type": "Speaker",
        "firstName": "Kelly",
        "lastName": "Timmins",
        "jobTitle": "Executive Director, Sustainability & Marine Animal Operations",
        "organization": "Atlantis Dubai",
        "photoUrl": "https://static.swapcard.com/public/images/02eff018fa2b45b284c73b529302d22e.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA2OTM1OA==",
                "title": "Bridging the Gap: Integrating SDGs into Core Business Strategies for Sustainable Success",
                "categories": [
                    "Restaurant Investment",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMxMzQ3OTI=",
        "type": "Speaker",
        "firstName": "Asad",
        "lastName": "Rahman",
        "jobTitle": "Senior Director",
        "organization": "Mashreq Bank",
        "photoUrl": "https://static.swapcard.com/public/images/19e8f85ab7374239bdbfdfbe224e7278.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzY0Nw==",
                "title": "Emergence of Real Estate Investment Trusts in the Middle East",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Bank/Lender",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMxMzUwNTY=",
        "type": "Delegate",
        "firstName": "Ottar",
        "lastName": "Zahl Jonassen",
        "jobTitle": "CEO & Founder",
        "organization": "Marelius AS",
        "photoUrl": "https://static.swapcard.com/public/images/219b03e499b54830b2ddcb62e74fbcc1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Nw==",
                "title": "The BIG Project Pitch: International Hospitality Projects Revealed",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Delegate",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMxMzUyNzg=",
        "type": "Speaker",
        "firstName": "Bernardo",
        "lastName": "Fort-Brescia",
        "jobTitle": "Founder & Principal",
        "organization": "Arquitectonica",
        "photoUrl": "https://static.swapcard.com/public/images/bbcbb3e0ceee4d2aa8ef13e91b65fdff.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgyMg==",
                "title": "Future Telling – What Shapes and Forms will Branded Residences Take in Coming Years",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMxODc1NjM=",
        "type": "Speaker",
        "firstName": "Rahul",
        "lastName": "Chaudhary",
        "jobTitle": "Managing Director & Global CEO",
        "organization": "CG Corp & CG Hospitality Holdings",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/b721a5a2424846a6affe9a863be8608f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzc0MA==",
                "title": "From Nepal to the World: A Journey of Strategic Investment, Development, and Asset Management",
                "categories": [
                    "Focus on Africa"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMxODc4MjY=",
        "type": "Speaker",
        "firstName": "Stephen",
        "lastName": "Rossouw",
        "jobTitle": "Director Development",
        "organization": "New Murabba Development Company",
        "photoUrl": "https://static.swapcard.com/public/images/f0f81072af1e4c2c94bef5b9af555e52.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA0OTQxNQ==",
                "title": "Branded Residences: A New Era in Real Estate Investment",
                "categories": [
                    "Branded Residences",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences",
                        "translations": [
                            {
                                "value": "Branded Residences"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMxODgxNjk=",
        "type": null,
        "firstName": "Josh",
        "lastName": "Craddock",
        "jobTitle": "Group Director Marketing",
        "organization": "EatX",
        "photoUrl": "https://static.swapcard.com/public/images/3c4433650b97428f9b9b17857559a442.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4MA==",
                "title": "Hoteliers Are From Mars, Restauranters Are From Venus: Why Hoteliers Can’t Run Restaurants?",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMxODgyMTA=",
        "type": "Speaker",
        "firstName": "Sammy",
        "lastName": "Gharieni",
        "jobTitle": "CEO / Founder",
        "organization": "Gharieni Group",
        "photoUrl": "https://static.swapcard.com/public/images/3384df8a5e7e4747991cc04402d79916.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk2MQ==",
                "title": "The Future of Wellness: Brand Challenges and Opportunities",
                "categories": [
                    "Wellness & Medical Tourism"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU4Nzc2OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "wellness-and-medical-tourism",
                        "translations": [
                            {
                                "value": "Wellness & Medical Tourism"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMxOTAwMDg=",
        "type": "Speaker",
        "firstName": "Jonathan",
        "lastName": "Tomlinson",
        "jobTitle": "Global Head and SVP Private Homes and Branded Residential",
        "organization": "Kerzner International",
        "photoUrl": "https://static.swapcard.com/public/images/db51b6ba212e49cdac8b72619b33cee5.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNw==",
                "title": "Operator Perspective - A Look at How Leading Operators of Branded Residences View their Relationship With Development Partners and Homeowner Communities",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMxOTA1Mzc=",
        "type": "Speaker",
        "firstName": "Errikos",
        "lastName": "Christodoulou",
        "jobTitle": "Hotel Operations Manager",
        "organization": "MarBella Collection",
        "photoUrl": "https://static.swapcard.com/public/images/16c7a7e85656472399326fde022e1935.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAzNTg1Mw==",
                "title": "FHS Awards 2024",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMyMDE1ODQ=",
        "type": "Speaker",
        "firstName": "Panchali",
        "lastName": "Mahendra",
        "jobTitle": "Chief Executive Officer",
        "organization": "Atelier House Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/83256e8bc5924829b3ceea5eaa24a983.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4MQ==",
                "title": "Beyond the Plate: Culinary Experiences as a Pillar of Destination Tourism",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMyMTAxMzg=",
        "type": "Speaker",
        "firstName": "Sissi",
        "lastName": "Johnson",
        "jobTitle": "President",
        "organization": "Berlin Fashion Film Festival",
        "photoUrl": "https://static.swapcard.com/public/images/f4c4a1eca30d4a26ae9c9cf323b7e0b6.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxMg==",
                "title": "Digital Transformation - The Future of Design and Customer Experience",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Media",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMyMTA3MDI=",
        "type": "Speaker",
        "firstName": "Tony",
        "lastName": "Miki",
        "jobTitle": "Partner",
        "organization": "Foster & Partners",
        "photoUrl": "https://static.swapcard.com/public/images/c4507dfe7e6f47218b9f1ef46bda730c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA1MTE5OQ==",
                "title": "New Horizons Ahead: Trends and Developments in Tomorrow’s Designs",
                "categories": [
                    "Projects & Destinations",
                    "Green Construction & Smart Cities",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "green-construction-and-smart-cities",
                        "translations": [
                            {
                                "value": "Green Construction & Smart Cities"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTU0Ng==",
                "title": "Building the Future: The Changing Face of Market and Investor Growth in The Maldives",
                "categories": [
                    "Projects & Destinations",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMyMTA4Mjg=",
        "type": "Moderator",
        "firstName": "Yosor",
        "lastName": "Al Suhaili",
        "jobTitle": "Principal & Head of Business Development",
        "organization": "Andart Global",
        "photoUrl": "https://static.swapcard.com/public/images/334f805667c24f969b2d1def4102b686.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA1MTE5OQ==",
                "title": "New Horizons Ahead: Trends and Developments in Tomorrow’s Designs",
                "categories": [
                    "Projects & Destinations",
                    "Green Construction & Smart Cities",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "green-construction-and-smart-cities",
                        "translations": [
                            {
                                "value": "Green Construction & Smart Cities"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMyMTM5NDQ=",
        "type": "Speaker",
        "firstName": "Marloes",
        "lastName": "Knippenberg",
        "jobTitle": "Chief Executive Officer",
        "organization": "Kerten Hospitality",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/aadc31d5ddd34fcabc0aca59a0182e30.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgyMDAxMw==",
                "title": "Case Study - Private and Public Sector Collaborate to Accelerate Lifestyle Developments and Promote New Destinations #Vision2030",
                "categories": [
                    "Brand & Destination",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
                "title": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzYwNw==",
                "title": "Sustainable Hospitality Challenge - The Hospitality Leaders of Tomorrow Reimagining our Industry",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMyNDgwMTU=",
        "type": "Speaker",
        "firstName": "Stephen",
        "lastName": "Ansell",
        "jobTitle": "Managing Director – Middle East and Africa",
        "organization": "Hyatt",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/68a36c2c3cde4c0ea405fdf3c809aa46.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgyMDAxNA==",
                "title": "Travelling for Good: Innovations in Luxury Travel for Responsible Tourism Development",
                "categories": [
                    "ESG & Human Capital"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTQwMQ==",
                "title": "Saudi Vision 2030: Reimagining Hospitality",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Saudi Arabia",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-saudi-arabia",
                        "translations": [
                            {
                                "value": "Focus on Saudi Arabia"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMyNTkxMjQ=",
        "type": "Speaker",
        "firstName": "Lorelei",
        "lastName": "Regragui",
        "jobTitle": "Founder & CEO",
        "organization": "StayK",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/76a30635a1ac4c9f9ea238fae8fb80dd.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                "title": "Start-Up Den",
                "categories": [
                    "Startup Den"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "startup-den",
                        "translations": [
                            {
                                "value": "Startup Den"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU5Ng==",
                "title": "Speaker’s Corner: From Setbacks to Triumphs",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NA==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Competitions"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "competitions",
                        "translations": [
                            {
                                "value": "Competitions"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMyNTkxNjc=",
        "type": "Speaker",
        "firstName": "Bell",
        "lastName": "Beh",
        "jobTitle": "Co-Founder",
        "organization": "BuzzAr",
        "photoUrl": "https://static.swapcard.com/public/images/62eab754d9c34074a16003f989e2e73d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NA==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Competitions"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "competitions",
                        "translations": [
                            {
                                "value": "Competitions"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMyNTkyNDM=",
        "type": "Speaker",
        "firstName": "Jessica",
        "lastName": "Scopacasa",
        "jobTitle": "Co-founder & CMO",
        "organization": "Olive Gaea",
        "photoUrl": "https://static.swapcard.com/public/images/757a8479de824de9887c18161b9d464c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NA==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Competitions"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "competitions",
                        "translations": [
                            {
                                "value": "Competitions"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMyNTkyNjc=",
        "type": "Speaker",
        "firstName": "Nisreen",
        "lastName": "Shadad",
        "jobTitle": "CEO/ Cofounder",
        "organization": "NetGreen",
        "photoUrl": "https://static.swapcard.com/public/images/beed45c140484682848bf5ca203d89a8.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NA==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Competitions"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "competitions",
                        "translations": [
                            {
                                "value": "Competitions"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMyNTk3MzQ=",
        "type": "Speaker",
        "firstName": "Dr. Hanin",
        "lastName": "Alsubaie",
        "jobTitle": "Chief Executive Officer",
        "organization": "Darent",
        "photoUrl": "https://static.swapcard.com/public/images/988268f602614ab1be24580a6b9b087a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NA==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Competitions"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "competitions",
                        "translations": [
                            {
                                "value": "Competitions"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMyODYxNTM=",
        "type": "Delegate",
        "firstName": "Marta",
        "lastName": "Garcia De Alcaraz",
        "jobTitle": "Co-founder and Business Development Director",
        "organization": "Salasia Group",
        "photoUrl": "https://static.swapcard.com/public/images/1d864b4c0eca4a70b4572e794fcb97bc.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Nw==",
                "title": "The BIG Project Pitch: International Hospitality Projects Revealed",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Delegate",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMyODY0Mzk=",
        "type": "Speaker",
        "firstName": "Rabih",
        "lastName": "Feghali",
        "jobTitle": "Board Member",
        "organization": "HAMA",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/bde0f2da88104f85b7b4d69ce0181547.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Nw==",
                "title": "The BIG Project Pitch: International Hospitality Projects Revealed",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Asset Manager",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzMDAwMDU=",
        "type": "Speaker",
        "firstName": "Sahar Parham Al",
        "lastName": "Awadhi",
        "jobTitle": "Pastry Chef",
        "organization": "",
        "photoUrl": "https://static.swapcard.com/public/images/19742ce33e094e79ab3ed975811d4773.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4MQ==",
                "title": "Beyond the Plate: Culinary Experiences as a Pillar of Destination Tourism",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzMDAxODE=",
        "type": "Speaker",
        "firstName": "Rana",
        "lastName": "Batterjee",
        "jobTitle": "Co-Founder & COO",
        "organization": "EduPloyment",
        "photoUrl": "https://static.swapcard.com/public/images/6d1ceccc3eb54ca49aa87f7ebf8a1754.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NA==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Competitions"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "competitions",
                        "translations": [
                            {
                                "value": "Competitions"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzMDAyMDI=",
        "type": "Speaker",
        "firstName": "Neha",
        "lastName": "Mishra",
        "jobTitle": "Founder",
        "organization": "Kinoya Restaurant Dubai - Michelin Bib Gourmand",
        "photoUrl": "https://static.swapcard.com/public/images/627664087f0145a6adb612f1ccb33dfe.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4MQ==",
                "title": "Beyond the Plate: Culinary Experiences as a Pillar of Destination Tourism",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzMDQ2Mjk=",
        "type": "Speaker",
        "firstName": "Dr. Suruchi",
        "lastName": "Mittar",
        "jobTitle": "Chief Industry Officer and Senior Vice President",
        "organization": "Invest India",
        "photoUrl": "https://static.swapcard.com/public/images/02b261c04d354fd79eb59ec48642de8c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjEzNDk0Mg==",
                "title": "India 2047: Unlocking the Future of Hospitality in a Rising Global Power",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE2MzcxOA==",
                "title": "Invest in India",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzMTk0NjE=",
        "type": "Speaker",
        "firstName": "Pier",
        "lastName": "Ezhaya",
        "jobTitle": "General Manager, Tour Operating",
        "organization": "Alpitour World",
        "photoUrl": "https://static.swapcard.com/public/images/1e15bf15c4254b19a477f8a8290a68f6.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA0OTU1Mg==",
                "title": "Invest in Italy:  Showcasing Unique Hospitality Projects",
                "categories": [
                    "Investment & Development",
                    "Projects & Destinations",
                    "Focus on Europe"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzMjAyNzI=",
        "type": "Speaker",
        "firstName": "Carlos",
        "lastName": "Leal",
        "jobTitle": "Executive Chairman and Board Member",
        "organization": "United Hospitality Management (UHM)",
        "photoUrl": "https://static.swapcard.com/public/images/ba4bdf48913f453abc302161a6447d06.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgyMw==",
                "title": "Structuring Rentals Programs to Appeal to Buyers, While Protecting the Interests of Hotel Owners & Developers",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzMjA1MjY=",
        "type": "Speaker",
        "firstName": "Christian",
        "lastName": "Gradnitzer",
        "jobTitle": "VP Business Development",
        "organization": "RIKAS Hospitality Group",
        "photoUrl": "https://static.swapcard.com/public/images/129c79dea51147c9b9a791b3ab5dee4d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4MA==",
                "title": "Hoteliers Are From Mars, Restauranters Are From Venus: Why Hoteliers Can’t Run Restaurants?",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzMjgxMzE=",
        "type": "Speaker",
        "firstName": "Amman",
        "lastName": "Shah",
        "jobTitle": "Executive Director",
        "organization": "Dubai Holding Investments",
        "photoUrl": "https://static.swapcard.com/public/images/9da5058d1bd54547acd5ede417a976ca.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjE0OTEyOQ==",
                "title": "Building the Future: The Changing Face of Market and Investor Growth in The Maldives",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzMjgyNzg=",
        "type": "Speaker",
        "firstName": "Benjamin",
        "lastName": "Habbel",
        "jobTitle": "Managing Partner & Co-Founder",
        "organization": "Limestone Capital",
        "photoUrl": "https://static.swapcard.com/public/images/dc7d8266959f4cfcbc4ce37b4df7e832.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA1MTE4OA==",
                "title": "European Hospitality Revival: Creating Investment Opportunities in Mature Markets",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Europe",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzMzAzNjA=",
        "type": "Speaker",
        "firstName": "Werner",
        "lastName": "Anzinger",
        "jobTitle": "General Manager & Area Vice President, Operations",
        "organization": "Mandarin Oriental Jumeira, Dubai",
        "photoUrl": "https://static.swapcard.com/public/images/ee7ac5e66a0a484fba76650fa1893b7e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA2OTM1NQ==",
                "title": "Global Expertise, Local Talent: Hospitality's Balancing Act",
                "categories": [
                    "Education Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3MjkwMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "education-investment",
                        "translations": [
                            {
                                "value": "Education Investment"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzMzMwNDU=",
        "type": "Speaker",
        "firstName": "Simon",
        "lastName": "Hasdell",
        "jobTitle": "Vice President Asset Management Hospitality",
        "organization": "IFA Hotels & Resorts",
        "photoUrl": "https://static.swapcard.com/public/images/81a36f2c97104729adb15b0005e61e09.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyOTk0MA==",
                "title": "HAMA Workshop & Annual Debriefing",
                "categories": [
                    "Workshop"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "workshop",
                        "translations": [
                            {
                                "value": "Workshop"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzMzU1OTg=",
        "type": "Speaker",
        "firstName": "Adelina",
        "lastName": "Wong Ettelson",
        "jobTitle": "Global Head of Residential Marketing",
        "organization": "Mandarin Oriental Hotel Group",
        "photoUrl": "https://static.swapcard.com/public/images/d99bf302a81248ae953388076d11e2a9.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNw==",
                "title": "Operator Perspective - A Look at How Leading Operators of Branded Residences View their Relationship With Development Partners and Homeowner Communities",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgxOQ==",
                "title": "Marketing Case Studies - Short Presentations by Leading Marketing Professionals Who Have Helped Drive the Success of Branded Residence Projects",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzNDU1NTQ=",
        "type": "Speaker",
        "firstName": "Duaa",
        "lastName": "Suliman",
        "jobTitle": "Founder",
        "organization": "Rifgaa",
        "photoUrl": "https://static.swapcard.com/public/images/933e5254029d480a854cd21ffea0b7fb.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NQ==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzNDU2MTU=",
        "type": "Speaker",
        "firstName": "Nouran",
        "lastName": "Farouk",
        "jobTitle": "Cofounder",
        "organization": "Dosy Bikes",
        "photoUrl": "https://static.swapcard.com/public/images/d35ebb3450504c59a4a64ab6b37ae6e8.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NQ==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzNDU4OTg=",
        "type": "Moderator",
        "firstName": "Raghuveer",
        "lastName": "Swamy",
        "jobTitle": "Student",
        "organization": "Emirates Academy of Hospitality Management",
        "photoUrl": "https://static.swapcard.com/public/images/3d7d149bb2fe47d9b41c719cd85b3662.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzNDYwNzE=",
        "type": "Speaker",
        "firstName": "Nurhan M.",
        "lastName": "Rani",
        "jobTitle": "Growth Manager & Cofounder",
        "organization": "ITHAKA",
        "photoUrl": "https://static.swapcard.com/public/images/87ebf2aec85e47ee908966247eb16eef.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NQ==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzNDYxMDE=",
        "type": "Speaker",
        "firstName": "Doaa Abdel",
        "lastName": "Hameed",
        "jobTitle": "Cofounder & CBO",
        "organization": "Bonbell",
        "photoUrl": "https://static.swapcard.com/public/images/038d2290446948ae811b5997193cb68f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NQ==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzMzNjQzMjU=",
        "type": "Judge",
        "firstName": "Gwen",
        "lastName": "Wunderlich",
        "jobTitle": "CEO & Founder",
        "organization": "WKC Global",
        "photoUrl": "https://static.swapcard.com/public/images/ad0303cf6b7f4a5e9a47d4fa4c6262d0.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NA==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Competitions"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "competitions",
                        "translations": [
                            {
                                "value": "Competitions"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NQ==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Judge",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzM0MTgxNDk=",
        "type": "Speaker",
        "firstName": "Sam",
        "lastName": "Bakhshandehpour",
        "jobTitle": "Global Chief Executive Officer",
        "organization": "José Andrés Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/46a16339843641dfae39ca89faaf369d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTg5NDQ2NQ==",
                "title": "Case study: What is your North Star? Profit with Purpose - From Restaurants to Global Media Powerhouse & Force for Good, learning from The José Andrés Group’s transformation",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4NA==",
                "title": "Unlocking F&B Success: Boosting Hotel Real Estate Value with Effective Third-Party Outlet Agreements",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzM0NjIxNTY=",
        "type": "Moderator",
        "firstName": "Khushi",
        "lastName": "Kumar",
        "jobTitle": "Students",
        "organization": "Emirates Academy of Hospitality Management",
        "photoUrl": "https://static.swapcard.com/public/images/cf5c2c7378fb492abc89a90ae41abd40.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzM0ODA0OTY=",
        "type": "Speaker",
        "firstName": "Zeinab",
        "lastName": "Zohny",
        "jobTitle": "Founder",
        "organization": "Zenn-AI",
        "photoUrl": "https://static.swapcard.com/public/images/7f1a8fa0bd6e4310bb1d55d458357157.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NQ==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzM1NDUyOTA=",
        "type": "Speaker",
        "firstName": "Nicolas",
        "lastName": "Roux",
        "jobTitle": "Founder and CEO",
        "organization": "Rive Gauche London",
        "photoUrl": "https://static.swapcard.com/public/images/b2857ac9a89e433cb44417ed8e864e1c.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1Ng==",
                "title": "Strategies to Drive the Development and Operation of Sustainable Homeowner Communities that Deliver on Health and Wellbeing Objectives",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzM1NDcxMjg=",
        "type": "Speaker",
        "firstName": "Wissal",
        "lastName": "Jarjour",
        "jobTitle": "Interior Designer",
        "organization": "Dubai Holding Investments",
        "photoUrl": "https://static.swapcard.com/public/images/148774464bc143e5a399abe7639af512.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1NQ==",
                "title": "The Leading Edge of Global Residential Markets - Examining The Role of Innovation, Architecture and Design in Branded Residence Projects",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzM1ODI1NTc=",
        "type": "Speaker",
        "firstName": "Maha",
        "lastName": "Al Gargawi",
        "jobTitle": "Vice-President of Business Advocacy",
        "organization": "Dubai Chambers",
        "photoUrl": "https://static.swapcard.com/public/images/89bb768bd62c4c82b92f9c237ccc3f23.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzY0OQ==",
                "title": "Leading with Purpose: Commitment to People, Planet and Profit",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzM2MTQyMzg=",
        "type": "Speaker",
        "firstName": "Nick",
        "lastName": "Candy",
        "jobTitle": "Chief Executive Officer",
        "organization": "Candy Capital",
        "photoUrl": "https://static.swapcard.com/public/images/a273c291d2894997a22b0a9250c95e4e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjE2MDE2OA==",
                "title": "From London to Dubai - Perspectives from a Pioneering Developer on the Future of Branded Living in the World's most Dynamic Market for Branded Real Estate",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzM2MTQ2NTk=",
        "type": "Moderator",
        "firstName": "Yasmine",
        "lastName": "Vanda Trofast",
        "jobTitle": "Founder & Owner",
        "organization": "YVT Consulting",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/bc950859492046ad952ecf3bfa045a74.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTg5MTg0MQ==",
                "title": "Empowering Hospitality: Leading the Way in Crafting a Diverse, Inclusive Lifestyle Brand and Transforming Human Experience",
                "categories": [
                    "ESG & Human Capital",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU1Nw==",
                "title": "Innovations and Trends Shaping the Future of Mobility",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzM2MTU3NzM=",
        "type": null,
        "firstName": "Saria",
        "lastName": "Alderhali",
        "jobTitle": "Founder",
        "organization": "Bondai",
        "photoUrl": "https://static.swapcard.com/public/images/c6bac05ca76e4d4a9cd6ebed0cfcfef9.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NQ==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Techology & AI"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Techology & AI"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzM2MTU4MDc=",
        "type": "Speaker",
        "firstName": "Jitesh",
        "lastName": "Shetty",
        "jobTitle": "CEO/Founder",
        "organization": "Credibl ESG Innovations",
        "photoUrl": "https://static.swapcard.com/public/images/a943c226aaa94af2a78d706d1e8d0a24.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjE2MDI3NA==",
                "title": "Data-Driven Sustainability: Transforming Hospitality with AI",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzM2MjE1Njc=",
        "type": "Speaker",
        "firstName": "Mohamed",
        "lastName": "Abdalla Al Zaabi",
        "jobTitle": "Group Chief Executive Officer",
        "organization": "Miral",
        "photoUrl": "https://static.swapcard.com/public/images/5c4360f526ca4929820c9cf6c6f60fea.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjE2MTEwMA==",
                "title": "Visionary Leadership: Driving Abu Dhabi’s Leisure and Entertainment Growth through Immersive Destinations",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzM2NjYzNTQ=",
        "type": null,
        "firstName": "Barry",
        "lastName": "Landsberg",
        "jobTitle": "Principal",
        "organization": "Landsberg Residential Consulting Inc.",
        "photoUrl": null,
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgyMw==",
                "title": "Structuring Rentals Programs to Appeal to Buyers, While Protecting the Interests of Hotel Owners & Developers",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNw==",
                "title": "Operator Perspective - A Look at How Leading Operators of Branded Residences View their Relationship With Development Partners and Homeowner Communities",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": []
        }
    }
] 